/** Copie italiane: unica fonte. L'inglese deve coprire le stesse chiavi. */

export const it = {
  'lang.group': 'Lingua',
  'cloud.looks': 'Che cosa si guarda',
  'cloud.noFrameButCloud': "Nessun fotogramma inquadra questo punto: si guarda la nuvola. La consegna non lo esporterà.",
  'cloud.lookPhoto': "Immagine",
  'cloud.lookCloud': 'Nuvola',
  'cloud.lookProfile': 'Profilo',
  'cloud.unavailableForSource': "Nuvola e profilo sono disponibili solo per candidati LiDAR.",
  'cloud.reading': 'Leggo la nuvola…',
  'cloud.notCut': "Il lembo di nuvola di questa anomalia non è ancora stato tagliato: si rifà dall'acquisizione (anomalies/recut).",
  'cloud.altCloud': 'La nuvola di punti attorno al candidato, in tre dimensioni: trascina per girare, rotella per avvicinare',
  'cloud.altProfile': 'Il profilo lungo la campata: il filo, il punto peggiore, il cerchio della soglia',
  'cloud.legendConductor': 'conduttori',
  'cloud.legendVegetation': 'vegetazione',
  'cloud.legendGround': 'terreno',
  'cloud.legendPole': 'sostegni',
  'cloud.legendBuilding': 'edifici',
  'cloud.points': 'punti entro {r} m',
  'cloud.norm': 'norma',
  'cloud.axisNote': "Senza campata registrata: l'asse è la direzione verso il filo.",
  'viewer.reading': 'Leggo il fotogramma…',
  "viewer.readingFor": "Leggo il fotogramma… {s} s — l'archivio è lento, non fermo",
  'viewer.unreadable': 'Il fotogramma non si apre: {why}',
  'viewer.scale': 'Scala',
  'viewer.frame': 'Fotogramma',
  'tab.login': 'Entra',
  'tab.pool': 'Commesse',
  'tab.job': "Panoramica",
  'tab.map': 'Mappa',
  'tab.photos': "Foto",
  'tab.anomalies': 'Anomalie',
  'tab.queue': 'Banco',
  'tab.coverage': 'Copertura',
  'tab.element': 'Elemento',
  'tab.quality': 'Qualità',
  'tab.delivery': 'Consegna',
  'tab.deliveries': 'Consegne',
  'tab.uploads': 'Caricamento',
  'tab.admin': 'Amministrazione',
  'tab.glossary': 'Glossario',
  'login.enter': 'Entra',
  'login.checking': 'Verifica…',
  'login.username': 'Identificativo',
  'login.password': "Parola d'ordine",
  'login.offline': 'Il servizio non ha risposto: riprovare fra poco.',
  'login.brandLabel': 'Che cosa fa GridFly',
  'login.claimBefore': 'Ogni anomalia,',
  'login.claimAccent': 'vista una volta',
  'login.claimAfter': 'e decisa bene.',
  'login.lead':
    'Verifica delle ispezioni aeree sulle linee elettriche: dal pacchetto di volo alla consegna SWIM, con il verdetto sempre annullabile e la ricevuta sempre rileggibile.',
  'login.footer': 'Nessun dato lascia questa installazione',
  'password.title': 'Cambio password obbligatorio',
  'password.lead':
    'Prima di accedere alle altre pagine bisogna sostituire la password temporanea.',
  'password.current': 'Password corrente',
  'password.next': 'Password nuova',
  'password.confirm': 'Conferma password nuova',
  'password.mismatch': 'Le due non coincidono.',
  'password.submit': 'Cambia password',
  'password.busy': 'Cambio…',
  'password.failed': 'Il cambio non è andato: riprovare.',
  'chrome.skip': 'Salta al contenuto',
  'chrome.signOut': 'Esci',
  'chrome.online': 'Online',
  'chrome.offline': 'Offline',
  'chrome.networkOn': 'Rete online',
  'chrome.networkOff': 'Rete offline',
  'chrome.outbox': 'Outbox {n}',
  'chrome.conflicts': 'Conflitti {n}',
  'chrome.identity': "Identità sessione",
  'chrome.commessa': 'Contesto commessa',
  'chrome.acquisitionUnknown': 'acquisizione n/d',
  'rail.modules': 'Moduli',
  'deliveries.loading': 'Lettura delle consegne…',
  'deliveries.readFailed': 'Le consegne non si leggono',
  'deliveries.emptyTitle': 'Nessuna consegna è ancora partita.',
  'deliveries.emptyAction': 'Le consegne compaiono qui quando una commessa viene inviata al committente.',
  'deliveries.colSent': 'Inviata il',
  'deliveries.colJob': 'Commessa',
  'deliveries.colDeclarations': 'Dichiarazioni',
  'deliveries.colState': 'Stato',
  'deliveries.colSignedBy': 'Firmata da',
  'deliveries.colChecksum': 'Impronta',
  'deliveries.submitted': 'Inviata',
  'deliveries.accepted': 'Accettata',
  'deliveries.rejected': 'Respinta',
  'deliveries.noAuthor': 'non registrato',
  'operations.loading': 'Lettura della sentinella…',
  'operations.readFailed': 'La sentinella non risponde',
  'operations.checkedAt': 'Controllato il {when} · {n} acquisizioni in lavorazione',
  'operations.recheck': 'Ricontrolla',
  'operations.quietTitle': 'La sentinella non vede guasti.',
  'operations.quietAction': 'Acquisizioni, code, copie e orologio sono a posto. La data del controllo sta qui sopra.',
  'operations.colWhat': 'Che cosa',
  'operations.colDetail': 'Da quando, e quanto',
  'operations.colFirstStep': 'Primo passo',
  'title.operations': 'Esercizio',
  'rail.operations': 'Esercizio',
  'rail.work': 'Commesse',
  'rail.workWaiting': 'Commesse · {n} da verificare',
  'rail.deliveries': 'Consegne',
  'rail.upload': 'Caricamento',
  'rail.admin': 'Amministrazione',
  'rail.help': 'Aiuto',
  'nav.sections': 'Sezioni commessa',
  'nav.overview': 'Panoramica',
  'nav.ingest': 'Ingest',
  'nav.coverage': 'Copertura',
  'nav.qa': 'Verifica',
  'nav.quality': 'Qualità',
  'nav.delivery': 'Consegna',
  'title.password': 'Cambio password',
  'title.upload': 'Caricamento del pacchetto',
  'title.uploadReceipt': "Ricevuta di caricamento",
  'title.ingest': "Ingest",
  'upload.openSessions': 'Caricamenti lasciati aperti',
  'upload.startedAt': 'iniziato il {when}',
  'upload.openedBy': ' · aperto da {who}',
  'upload.resumeHint': 'Scegliere di nuovo la cartella: ciò che è già arrivato non riparte.',
  'who.uploader': 'chi carica i pacchetti',
  'who.qa': 'un operatore di qualità',
  'who.supervisor': 'un supervisore',
  'who.manager': 'chi amministra l’installazione',
  'unreachable.title': 'Il servizio non risponde',
  'unreachable.body': 'La pagina riprova da sola ogni pochi secondi. Il lavoro non è perso: l’accesso e la casella d’uscita restano su questa postazione.',
  'privacy.title': 'Anonimizzazione',
  'privacy.unread': 'Lo stato dell’anonimizzazione non si legge.',
  'privacy.done': 'Fatta',
  'privacy.pending': 'Da fare',
  'privacy.scanned': '{n} fotogrammi guardati su {total}',
  'privacy.noneFound': 'Nessun volto e nessuna targa nei fotogrammi guardati.',
  'privacy.found': '{zones} zone da coprire su {frames} fotogrammi.',
  'privacy.scan': 'Cerca volti e targhe',
  'privacy.rescan': 'Cerca di nuovo',
  'privacy.starting': 'Scansione accodata…',
  'title.deliveries': 'Consegne',
  'title.pool': 'Commesse',
  'title.poolShared': 'Il pool è condiviso: chi apre la coda prende i candidati in prestito.',
  'title.commessa': "Panoramica",
  'title.queue': "Banco",
  'title.desk': "Banco",
  'title.search': 'Foto',
  'title.coverage': 'Copertura',
  'title.quality': "Campione di qualità",
  'lifecycle.stage.reception': 'Ricezione pacchetto',
  'lifecycle.stage.integrity': "Verifica integrità",
  'lifecycle.stage.georeferencing': 'Georeferenziazione',
  'lifecycle.stage.cloud': 'Nuvola e franchi',
  'lifecycle.stage.detection': 'Rilevamento anomalie',
  'lifecycle.stage.ready': 'Pronto per verifica',
  'lifecycle.count.objects': 'Oggetti ricevuti',
  'lifecycle.count.bytes': 'Peso ricevuto',
  'lifecycle.count.frames': 'Fotogrammi',
  'lifecycle.count.located': 'Con coordinate',
  'lifecycle.count.dated': 'Con marca temporale',
  'lifecycle.count.bound': 'Agganciati a un elemento',
  'lifecycle.count.spans': 'Campate ricostruite',
  'lifecycle.count.measured': 'Violazioni misurate',
  'lifecycle.count.gauged': 'Con dettaglio a terra',
  'lifecycle.count.predicted': 'Predizioni del modello',
  'lifecycle.count.waiting': 'In coda di verifica',
  'error.reviewFrozen': "La verifica ordinaria è chiusa: la commessa è congelata per il controllo di qualità.",
  'title.delivery': 'Consegna',
  'title.exportReceipt': "Ricevuta di consegna",
  'title.users': 'Utenti',
  'title.model': 'Modello',
  'title.settings': 'Impostazioni',
  'title.catalog': 'Catalogo',
  'title.audit': 'Registro audit',
  'guard.opening': 'Apertura…',
  'guard.denied': 'Accesso negato (403)',
  'guard.requires': 'Questa pagina è di {who}.',
  'guard.noSafe': 'Nessuna destinazione consentita e disponibile da questa sessione.',
  'guard.openSafe': 'Apri una destinazione consentita',
  'notFound.title': 'Pagina non trovata',
  'notFound.body': "L'indirizzo richiesto non esiste nel workflow V1.",
  'notFound.pool': 'Apri il pool di lavoro',
  'cockpit.decision': 'Decisione',
  'cockpit.confirm': 'Conferma come proposta',
  'cockpit.falsePositive': 'Falso positivo',
  'cockpit.defer': 'Rinvia alla coda',
  'cockpit.manual': 'Apri la trovata manuale',
  'cockpit.undo': 'Annulla',
  'cockpit.undoSeconds': 'Annulla · {n} s',
  'cockpit.firstVerdicts': 'Un verdetto si annulla entro cinque secondi, con Ctrl+Z o col comando qui sopra. Dopo, si corregge dalla scheda Anomalie.',
  'cockpit.chooseRank': 'Scegli il rango',
  'cockpit.ranks': 'Ranghi',
  'cockpit.confirmRank': 'Conferma cambiando il rango',
  'cockpit.chooseReason': 'Scegli il motivo',
  'cockpit.rejectReasons': 'Motivi del rifiuto',
  'cockpit.rejectWithReason': 'Rifiuta con un motivo',
  'cockpit.rejectWithReasonCmd': 'Rifiuta con motivo…',
  'cockpit.rankHint': 'S poi la cifra',
  'cockpit.measured': 'Misurata',
  'cockpit.marginLabel': 'Margine',
  'cockpit.confidenceOf': 'Confidenza del modello {n}',
  'reason.nonAnomalia': "Non è un'anomalia",
  'reason.altroTipo': 'Anomalia di tipo diverso',
  'reason.duplicato': 'Duplicato',
  'reason.illeggibile': 'Fotogramma illeggibile',
  'reason.elementoErrato': 'Elemento di rete sbagliato',
  'cockpit.sourceModel': 'modello',
  'cockpit.sourceManual': 'dichiarata a mano',
  'cockpit.sourceImport': 'importata',
  'pool.jobs': 'Commesse',
  'pool.readFailed': 'Le commesse non si leggono',
  'pool.requestId': 'richiesta {id}',
  'pool.routeState': 'Stato route del pool',
  'pool.filterStatus': "Quali commesse",
  'pool.sort': 'Ordine',
  'pool.sortPriority': 'Prima chi aspetta di più',
  'pool.sortRecent': 'Prima le più recenti',
  'pool.sortActivity': 'Prima chi si è mosso per ultimo',
  'pool.page': 'Pagina',
  'pool.filterFrozen': 'Congelate',
  'pool.frozenEmptyTitle': 'Adesso nessuna commessa è congelata.',
  'pool.frozenEmptyAction': 'Una commessa si congela quando il supervisore chiude la verifica per il controllo di qualità. Fino ad allora sta fra le altre.',
  'pool.pageOf': 'Pagina {n} di {m}',
  'pool.prevPage': 'Pagina precedente',
  'pool.nextPage': 'Pagina successiva',
  'crumb.path': 'Percorso',
  'nav.adminSections': 'Sezioni amministrazione',
  'ingest.openJob': 'Apri la commessa',
  'receipt.openDeliveries': 'Consegne',
  'deliveries.openReceipt': 'Ricevuta',
  'deliveries.openJob': 'Commessa',
  'pool.loading': 'Lettura delle commesse…',
  'pool.emptyTitle': "Nessun pacchetto è ancora stato acquisito.",
  'pool.emptyAction': 'Apri un’utenza QA oppure carica un pacchetto.',
  'pool.colJob': 'Commessa',
  'pool.colStatus': 'Stato',
  'pool.colWaiting': 'Da verificare',
  'pool.colLeased': 'In lavorazione',
  'pool.colDecided': 'Decise',
  'pool.colAcquired': 'Acquisita',
  'pool.colPlant': 'Impianto',
  'pool.colOperators': 'Chi ci lavora',
  'pool.kpiReview': 'Da verificare',
  'pool.kpiReviewLine': '{jobs} commesse · {n} anomalie',
  'pool.kpiWorst': 'peggiore {rank}',
  'pool.kpiProgress': 'In lavorazione',
  'pool.kpiProgressLine': '{n} candidati in mano · {people} persone',
  'pool.kpiStale': 'Ferme',
  'pool.kpiStaleLine': '{n} commesse senza movimento da 3 giorni',
  'pool.kpiDelivery': 'In consegna',
  'pool.kpiDeliveryLine': '{frozen} congelate · {sent} con consegna',
  'pool.mapArea': 'La rete',
  'pool.mapHint':
    'Ogni traccia è una commessa, col colore del suo stato in tabella. Clic sulla traccia la sceglie; la riga in tabella la accende qui.',
  'pool.mapTitle': 'Le {n} commesse sulla rete',
  'pool.mapJob': 'Commessa {id}',
  'pool.mapReading': 'Leggo la rete…',
  'pool.mapEmpty': 'Nessuna commessa ha ancora una posizione sulla rete.',
  'pool.colActivity': 'Ultimo movimento',
  'pool.nobody': 'nessuno',
  'pool.never': 'mai',
  'pool.inQualityControl': 'In controllo qualità',
  'pool.openQueue': "Apri il banco",
  'pool.openJob': 'Apri la commessa',
  'pool.filterInReview': "Con lavoro",
  'pool.filterReady': "Tutte",
  'pool.filterEmptyTitle': "Adesso nessuna commessa ha candidati da giudicare.",
  'pool.filterEmptyAction': "Non è un guasto: è una giornata senza lavoro nuovo. Le commesse si possono comunque aprire per guardarle.",
  'pool.showInReview': "Mostra tutte le commesse",
  'pool.statusError': 'Errore',
  'pool.statusProcessing': 'Elaborazione',
  'pool.statusQueued': 'In coda',
  'pool.statusToReview': 'Da verificare',
  'pool.statusDelivered': 'Consegnato',
  'pool.statusReady': 'Pronto',
  'role.uploader': 'Chi carica i pacchetti',
  'role.qa_operator': 'Operatore di verifica',
  'role.supervisor': 'Supervisore',
  'role.job_manager': 'Responsabile della commessa',
  'users.heading': 'Utenti',
  'users.readFailed': 'Le utenze non si leggono.',
  'users.requestFailed': 'Il servizio non ha accettato la richiesta.',
  'users.passwordTitle': "Parola d'ordine da consegnare",
  'users.passwordAccount': 'Utenza {login} ({name}).',
  'users.passwordNote':
    "Si vede una volta sola: non è rileggibile, in archivio resta solo la sua impronta. Va consegnata a voce o di persona, e chi la riceve deve cambiarla al primo accesso. Se si perde, se ne genera un'altra.",
  'users.passwordClose': 'Consegnata, chiudi',
  'users.openTitle': "Apri un'utenza",
  'users.displayName': 'Nome per esteso',
  'users.role': 'Ruolo',
  'users.openSubmit': 'Apri e consegna la parola',
  'users.openHint':
    "Il nome per esteso comparirà accanto ai verdetti: un identificativo non dice a nessuno chi ha giudicato.",
  'users.listTitle': 'Chi lavora nella piattaforma',
  'users.loading': 'Lettura utenze…',
  'users.colLogin': 'Identificativo',
  'users.colName': 'Nome',
  'users.colRole': 'Ruolo',
  'users.colStatus': 'Stato',
  'users.colActions': 'Azioni',
  'users.roleOf': 'Ruolo di {login}',
  'users.active': 'Attiva',
  'users.inactive': 'Disattivata',
  'users.mustChange': 'deve cambiare la parola',
  'users.deactivate': 'Disattiva',
  'users.reactivate': 'Riattiva',
  'users.resetPassword': 'Consegna una parola nuova',
  'users.listHint':
    "Nessuno si cancella: un verdetto ha un autore, e un autore cancellato rende quel verdetto non verificabile. Le utenze disattivate restano in elenco perché sono gli autori di verdetti già dati.",
  'common.dash': '—',
  'common.none': 'nessuna',
  'common.noneMasc': 'nessuno',
  'common.no': 'no',
  'common.close': 'Chiudi',
  'common.prevPage': 'Pagina precedente',
  'common.nextPage': 'Pagina successiva',
  'common.search': 'Cerca',
  'settings.intro':
    "Tutte le decisioni, non le sole ipotesi: una schermata che mostrasse solo le ipotesi farebbe sembrare immutabile ciò che il committente ha risposto.",
  'settings.loading': 'Lettura delle decisioni…',
  'settings.readFailed': 'Le decisioni non si leggono.',
  'settings.historyFailed': 'La storia non si legge.',
  'settings.versionFailed': "La versione non è stata registrata.",
  'settings.invalidJson': 'Il valore non è scritto in JSON: usare true, false, 2 oppure [1, 2].',
  'settings.colDecision': 'Decisione',
  'settings.colValue': 'Valore',
  'settings.colSource': 'Origine',
  'settings.colVersion': 'Versione',
  'settings.colHistory': 'Cronologia',
  'settings.critical': 'critica',
  'settings.criticalTitle': "Pesa su ciò che si consegna: cambiarla richiede una motivazione",
  'settings.hypothesis': ' · ipotesi',
  'settings.openHistory': 'Apri la storia',
  'settings.historyTitle': 'Cronologia',
  'settings.historyLoading': 'Lettura della storia…',
  'settings.noVersions':
    'Nessuna versione registrata: il valore corrente viene dalla migrazione iniziale.',
  'settings.colReason': 'Motivazione',
  'settings.colDecidedBy': 'Deciso da',
  'settings.colWhen': 'Quando',
  'settings.registerTitle': 'Registra una versione',
  'settings.valueJson': 'Valore (JSON)',
  'settings.source': 'Origine',
  'settings.questionRef': 'Domanda aperta',
  'settings.reasonRequired': 'Motivazione (obbligatoria)',
  'settings.reasonOptional': 'Motivazione (facoltativa)',
  'settings.criticalNote':
    "Questa decisione pesa su ciò che si consegna: senza motivazione il servizio rifiuta, e il rifiuto resta nel giornale.",
  'settings.submit': 'Registra la versione',
  'settings.sourceCustomer': 'Risposta del committente',
  'settings.sourceNorm': 'Norma o allegato contrattuale',
  'settings.sourceHypothesis': 'Ipotesi in attesa di risposta',
  'model.loading': 'Lettura delle cifre…',
  'model.readFailed': 'Lo stato del modello non si legge.',
  'model.shown': 'si mostrano all’operatore',
  'model.hidden': 'restano in ombra',
  'model.predictionsLead': 'Le predizioni',
  'model.metricsCaption': 'Cifre su tutte le {n} commesse misurate, non su una scelta',
  'model.colMetric': 'Metrica',
  'model.colMeasured': 'Misurata',
  'model.colThreshold': 'Soglia contrattuale',
  'model.r1': 'R1 — anomalie ritrovate',
  'model.r2': 'R2 — livello corretto',
  'model.errorRate': 'E — predizioni errate',
  'model.declared': 'Anomalie dichiarate',
  'model.predicted': 'Predizioni prodotte',
  'model.matched': 'Corrispondenze',
  'model.shortfall': 'Che cosa manca',
  'model.hide': 'Rimetti in ombra',
  'model.show': 'Mostra le predizioni',
  'model.notAcceptable':
    "Le cifre non consentono di mostrare il modello. Mostrare candidati che nessuno ha misurato fa spendere all'operatore il proprio tempo per valutare il modello invece che la linea.",
  'catalog.importTitle': "Porta dentro un'estrazione",
  'catalog.importFile': "File dell'estrazione (JSON)",
  'catalog.importNote':
    "Importare non mette in vigore, nemmeno la prima edizione: l'attivazione è una decisione a parte.",
  'catalog.importedNew': ', edizione nuova',
  'catalog.importedUpdated': ', edizione aggiornata',
  'catalog.notActivated': "Non è stata messa in vigore.",
  'catalog.importedPrefix': 'Importata',
  'catalog.importStats':
    'Aggiunti {added}, aggiornati {updated}, invariati {unchanged}. Punti aperti: {conflicts}.',
  'catalog.releases': 'Edizioni',
  'catalog.releasesLoading': 'Lettura delle edizioni…',
  'catalog.releasesEmpty': 'Nessuna edizione importata.',
  'catalog.colDocument': 'Documento',
  'catalog.colActive': 'In vigore',
  'catalog.colContent': 'Contenuto',
  'catalog.colOpen': 'Punti aperti',
  'catalog.colImported': 'Importata',
  'catalog.colActions': 'Azioni',
  'catalog.active': 'in vigore',
  'catalog.activeSince': ' dal {date}',
  'catalog.contentSummary': "{n} criticità, {codes} codici",
  'catalog.openCount': '{n} da chiarire',
  'catalog.activate': 'Metti in vigore',
  'catalog.releasesNote':
    "Di attiva ce n'è esattamente una: metterne in vigore un'altra spegne la precedente nella stessa transazione. Le edizioni non attive restano perché sono quelle con cui le consegne passate sono state prodotte.",
  'catalog.conflictsTitle': 'Punti aperti da chiarire col committente',
  'catalog.conflictsLoading': 'Lettura dei punti aperti…',
  'catalog.colSubject': 'Oggetto',
  'catalog.colIssue': 'Che cosa non torna',
  'catalog.colDetail': 'Dettaglio',
  'catalog.conflictsNote':
    "Non impediscono l'attivazione: sono domande sul documento, e tenere fuori vigore un catalogo per esse fermerebbe il lavoro.",
  'catalog.readFailed': 'Le edizioni non si leggono.',
  'catalog.conflictsFailed': 'I punti aperti non si leggono.',
  'catalog.notJson': 'Il file non è un documento JSON.',
  'catalog.fileUnreadable': 'Il file non si legge.',
  'catalog.conflictDisputed': 'Livelli discordanti fra le fonti del documento',
  'catalog.conflictMissing': 'Scheda citata ma assente dal documento',
  'catalog.conflictUnknown': 'Livelli ammessi non ricavabili dal documento',
  'audit.filters': 'Filtri del giornale',
  'audit.since': 'Dal giorno',
  'audit.until': 'Fino al giorno',
  'audit.action': 'Azione',
  'audit.actor': 'Chi ha agito',
  'audit.actorPlaceholder': "identificativo dell'utenza",
  'audit.subjectType': 'Tipo di soggetto',
  'audit.subject': 'Soggetto',
  'audit.pageSize': 'Eventi per pagina',
  'audit.readFailed': 'Il giornale non si legge.',
  'audit.exportFailed': "L'esportazione non è disponibile.",
  'audit.loading': 'Lettura del giornale…',
  'audit.noMatch': 'Nessun evento con questi filtri.',
  'audit.empty': 'Il giornale è vuoto: si riempie da solo con la prima azione registrata — un verdetto, una consegna, un cambio di impostazione.',
  'audit.pageSummary': '{total} eventi, pagina {page} di {pages}.',
  'audit.colWhen': 'Quando',
  'audit.colAction': 'Azione',
  'audit.colWho': 'Chi',
  'audit.colSubject': 'Soggetto',
  'audit.colDetail': 'Dettaglio',
  'audit.service': 'servizio',
  'audit.pages': 'Pagine del giornale',
  'audit.prepareExport': 'Prepara il foglio degli eventi filtrati',
  'audit.downloadExport': 'Scarica il foglio',
  'audit.limitsNote':
    'Al massimo {maxSize} eventi per pagina e {maxExport} per esportazione: sono tetti del servizio, e oltre il tetto la richiesta viene rifiutata invece di essere troncata in silenzio. Il giornale è di sola lettura: gli eventi non si modificano e non si cancellano.',
  'rank.s0': 'Conforme',
  'rank.s1': 'Lieve',
  'rank.s2': 'Media',
  'rank.s3': 'Grave',
  'rank.s4': 'Critica',
  'rank.unranked': 'Grado non dichiarato',
  'margin.unmeasured': 'Non misurabile',
  'margin.violation': 'Violazione',
  'margin.critical': 'Margine critico',
  'margin.reduced': 'Margine ridotto',
  'margin.compliant': 'Conforme',
  'keys.handRight': 'Navigazione · mano destra',
  'keys.handLeft': 'Verdetti · mano sinistra',
  'keys.handCanvas': 'Tela',
  'keys.handGlobal': 'Globali',
  'keys.nextFinding': 'Trovata successiva',
  'keys.previousFinding': 'Trovata precedente',
  'keys.nextFrame': 'Fotogramma successivo nel volo (stessa camera)',
  'keys.previousFrame': 'Fotogramma precedente nel volo',
  'keys.confirm': 'Conferma come proposta',
  'keys.rankMode': 'Conferma cambiando il rango, poi la cifra S1…S4',
  'keys.falsePositive': 'Falso positivo',
  'keys.defer': 'Rinvia alla coda un candidato non deciso',
  'keys.manual': 'Apri la ricerca libera per una trovata manuale',
  'keys.confirmRank': 'Conferma al rango S2…S4',
  'keys.rejectReason': 'Rifiuta con un motivo, poi la cifra del motivo',
  'keys.redrawBox': 'Ridisegna il riquadro',
  'keys.drawPolygon': 'Disegna il contorno',
  'keys.zoomOne': 'Scala 1:1',
  'keys.zoomFit': 'Inquadra il fotogramma',
  'keys.zoomFinding': 'Avvicina alla trovata',
  'keys.hideOverlays': 'Tieni premuto: nasconde i disegni',
  'keys.undo': 'Annulla l’ultimo verdetto',
  'keys.help': 'Mappa dei tasti',
  'keys.toggleQueue': 'Chiudi o apri la pellicola dei fotogrammi',
  'keys.exitMode': 'Esci dal modo',
  'keys.close': 'Chiudi la mappa',
  'keys.openElement': "Apri la scheda dell'elemento",
  'cockpit.openElement': "Scheda dell'elemento",
  'cockpit.noElementExit': "La scheda dell'elemento si apre dal banco della commessa: questa schermata non ha l'uscita.",
  'cockpit.noElement': "Questo candidato non sta su un elemento della rete: non c'è una scheda da aprire.",
  'title.element': "Scheda dell'elemento",
  'coverage.colSheet': 'Scheda',
  'coverage.openSheet': 'Scheda di {id}',
  'element.reading': 'Leggo la scheda…',
  'element.heading': '{type} {id}',
  'element.line': 'Linea',
  'element.code': 'Codice',
  'element.endNodes': 'Nodi estremi',
  'element.position': 'Posizione',
  'element.notInspected': 'Non ispezionato',
  'element.frames': 'Fotogrammi',
  'element.noFrames': 'Nessun fotogramma inquadra questo elemento.',
  'element.frameCounts': '{candidates} candidati · {findings} constatazioni',
  'element.frameReviewed': 'guardato',
  'element.framePrimary': 'principale',
  'element.candidates': 'Candidati',
  'element.noCandidates': 'Nessun candidato su questo elemento.',
  'element.colCode': 'Codice',
  'element.colLevel': 'Livello',
  'element.colMargin': 'Margine',
  'element.colFrame': 'Fotogramma',
  'element.colVerdict': 'Verdetto',
  'element.colOpen': 'Apri',
  'element.openCandidate': 'Apri nel banco',
  'element.undecided': 'da decidere',
  'element.confirmed': 'confermato',
  'element.rejected': 'respinto',
  'element.withdrawn': 'ritirato',
  'element.findings': 'Constatazioni',
  'element.noFindings': 'Nessuna constatazione scritta su questo elemento.',
  'element.history': 'Voli passati',
  'element.noHistory': 'Questo elemento non compare in altre commesse.',
  'element.pastFlight': 'Commessa {id} · {when}',
  'element.pastCounts': '{frames} fotogrammi · {findings} constatazioni',
  'element.backToCandidate': 'Torna al candidato',
  'element.backToQueue': "Torna al banco",
  'element.openCoverage': 'Apri la copertura',
  'box.missing': 'Manca {field} del riquadro.',
  'box.notInteger': '{field} del riquadro vuole un numero intero di pixel.',
  'box.outside': "Il riquadro non può partire fuori dal fotogramma.",
  'box.noArea': 'Un riquadro senza area non indica niente: larghezza e altezza sopra zero.',
  'box.overflowWidth': 'Il riquadro esce dal fotogramma in larghezza (massimo {n} px).',
  'box.overflowHeight': 'Il riquadro esce dal fotogramma in altezza (massimo {n} px).',
  'box.fieldWidth': 'larghezza',
  'box.fieldHeight': 'altezza',
  'cockpit.statePending': 'In attesa di verdetto',
  'cockpit.stateDecisionPending': 'Decisione in consegna',
  'cockpit.stateApplied': 'Verdetto registrato',
  'cockpit.stateWithdrawn': 'Verdetto ritirato: il candidato aspetta di nuovo',
  'cockpit.stateRejected': 'Verdetto non registrato: va ripreso e deciso di nuovo',
  'cockpit.stateStale': "Il candidato è tornato in coda: va ripreso e deciso di nuovo",
  'cockpit.stateDeferred': 'Rinviato alla coda',
  'cockpit.stateOffline':
    "Offline · nessuna nuova acquisizione: si decide ciò che si tiene in mano",
  'cockpit.stateDegraded': 'Connessione degradata: il battito non arriva al servizio',
  'cockpit.stateReconciling': 'Riconciliazione in corso: prima di applicare altro',
  'cockpit.stateContended': "Nessun candidato libero: la commessa è in mano ad altri",
  'cockpit.stateExhausted': 'Batch esaurito: chiudi la sessione o torna al pool',
  'cockpit.stateClosed': 'Sessione chiusa: i candidati sono tornati alla coda',
  'cockpit.leaseMine': 'in mano a te',
  'cockpit.leasePending': 'decisione in consegna',
  'cockpit.leaseOthers': 'in mano ad altri',
  'cockpit.leaseAvailable': 'disponibile',
  "common.unreachable": "Il servizio non ha risposto.",
  "ingest.phaseDone": "Fatto",
  "ingest.phase.verify.name": "Verifica del pacchetto",
  "ingest.phase.verify.says": "controlla che il pacchetto sia integro e completo: manifesto, firme, cartelle attese",
  "ingest.phase.inventory.name": "Inventario",
  "ingest.phase.inventory.says": "conta e registra che cosa c'è dentro: camere, scatti, nuvole, traiettoria",
  "ingest.phase.passport.name": "Passaporto della linea",
  "ingest.phase.passport.says": "legge l'anagrafica di rete: quali sostegni e campate esistono su questa linea",
  "ingest.phase.telemetry.name": "Traiettoria",
  "ingest.phase.telemetry.says": "legge dove stava il drone in ogni istante, per posare ogni scatto nello spazio",
  "ingest.phase.media.name": "Fotogrammi",
  "ingest.phase.media.says": "legge ogni scatto e i suoi dati: uno illeggibile viene messo da parte, non ferma il resto",
  "ingest.phase.binding.name": "Associazione",
  "ingest.phase.binding.says": "lega ogni fotogramma all'elemento della rete che inquadra",
  "ingest.phase.coverage.name": "Copertura",
  "ingest.phase.coverage.says": "misura quali elementi sono stati visti e quali no: i buchi si vedono qui",
  "ingest.phase.analysis.name": "Distanze sulla nuvola",
  "ingest.phase.analysis.says": "misura i franchi fra il filo e ciò che c'è sotto, elemento per elemento",
  "ingest.phase.inference.name": "Modello",
  "ingest.phase.inference.says": "chiede al modello che cosa vede negli scatti: nascono i candidati da giudicare",
  "ingest.phase.report.name": "Rapporto",
  "ingest.phase.report.says": "scrive il riepilogo dell'acquisizione e apre la commessa al lavoro",
  "upload.heading": "GridFly — caricamento",
  "upload.folder": "Cartella del volo",
  "upload.noManifest": "In questa cartella non c’è dataset.json: o è la cartella sbagliata, o il pacchetto è incompleto.",
  "upload.badJson": "dataset.json non si legge come JSON: il file è rovinato o troncato.",
  "upload.missingFiles": "{n} file non sono arrivati. Ciò che c’è resta: ripartendo si manda solo quello che manca.",
  "upload.interrupted": "Il caricamento si è interrotto. Ripartendo si manda solo quello che manca.",
  "upload.filesIn": "{n} file, {size}",
  "upload.inRoot": " in {root}",
  "upload.outside": "{n} file stanno fuori dalla cartella del pacchetto e non verranno caricati.",
  "upload.reading": "Lettura in corso…",
  "upload.sending": "Invio in corso…",
  "upload.send": "Carica",
  "upload.progress": "Avanzamento",
  "upload.progressStatus": "{done} di {total} file — {bytesDone} di {bytesTotal} ({percent})",
  "upload.failedRetry": "{n} non sono passati al primo giro: verranno ripresi.",
  "upload.doneTitle": "Pacchetto caricato",
  "upload.doneObjects": "{n} oggetti. L’acquisizione",
  "upload.doneWorking": "è in lavorazione: non serve fare altro.",
  'upload.openReceipt': "Apri la ricevuta",
  'upload.openIngest': "Apri l'ingest",
  "upload.cannot": "Non si può caricare",
  "upload.note": "Da sapere",
  "upload.unnamed": "Rilievo senza nome",
  "upload.surveyType": "Tipo di rilievo",
  "upload.undeclared": "non dichiarato",
  "upload.crs": "Sistema di coordinate",
  "upload.clouds": "Nuvole",
  "upload.trajectory": "Traiettoria",
  "upload.present": "presente",
  "upload.absent": "assente",
  "upload.swim": "SWIM in ingresso",
  "upload.total": "Totale",
  "upload.filesSize": "{n} file, {size}",
  "upload.cameras": "Camere",
  "upload.noCameras": "Nessuna camera dichiarata nel manifesto.",
  "upload.colCamera": "Camera",
  "upload.colFolder": "Cartella",
  "upload.colFrames": "Scatti",
  "upload.colPose": "Pose",
  "upload.presentPl": "presenti",
  "upload.absentPl": "assenti",
  "upload.untreated": "Non trattati: {names}. Sono dati arrivati dal volo e non usati.",
  "upload.fixFolder": "Correggere la cartella e sceglierla di nuovo.",
  "receipt.unavailable": "Ricevuta non disponibile",
  "receipt.unread": "La ricevuta non si legge.",
  "receipt.reading": "Lettura ricevuta…",
  "receipt.offline": "Snapshot offline in sola lettura: {when}.",
  "receipt.upload": "Caricamento",
  "receipt.jobIngest": "Job ingest",
  "receipt.package": "Pacchetto",
  "receipt.sha256": "SHA-256",
  "receipt.objects": "Oggetti",
  "receipt.bytes": "Byte",
  "receipt.author": "Autore",
  "receipt.serverTime": "Ora server",
  "receipt.prepare": "Prepara ricevuta da scaricare",
  "receipt.download": "Scarica ricevuta",
  "receipt.undownloadable": "La ricevuta non si scarica in questo momento.",
  "ingest.unread": "Il monitor ingest non risponde.",
  "ingest.unavailable": "Monitor ingest non disponibile",
  "ingest.reading": "Lettura monitor ingest…",
  "ingest.offline": "Snapshot offline in sola lettura: {when}. Retry disabilitato.",
  "ingest.job": "Job",
  "ingest.state": "stato",
  "ingest.attempts": "tentativi",
  "ingest.retry": "Retry",
  "overview.heading": "Contesto commessa",
  "overview.empty": "Questa commessa non è nel pool",
  "overview.emptyAction": "O l'indirizzo è vecchio, o la commessa è di un'altra installazione. L'elenco dice che cosa c'è davvero.",
  "overview.reading": "Lettura della commessa…",
  "overview.offlineNoSnapshot": "Rete assente e nessuno snapshot da leggere.",
  "overview.offlineNote": "Offline, sola lettura: ultimo snapshot {when}. Da qui non si muta niente.",
  "overview.offlineBare": "Offline, sola lettura. Da qui non si muta niente.",
  "overview.job": "Commessa",
  "overview.activityUnknown": "Attività non dichiarata",
  "overview.acquisition": "acquisizione",
  "overview.deliveryWord": "consegna",
  "overview.nextAction": "Prossima azione",
  "overview.blockers": "Blocchi",
  "overview.noBlockers": "Nessun blocco operativo in questo momento.",
  "overview.lifecycle": "Ciclo di vita",
  "overview.lifecycleHint": "Sola lettura da qui: riprendere una fase si chiede a {who}.",
  "overview.lifecycleMissing": "Lifecycle non disponibile in questa sessione.",
  "overview.metrics": "Metriche",
  "overview.metricsMissing": "Metriche non disponibili: assente non è zero.",
  "overview.waiting": "In attesa",
  "overview.decided": "decisi",
  "overview.gaps": "buchi",
  "overview.sample": "campione",
  "overview.openProgress": "Apri avanzamento",
  "overview.anomalies": "Anomalie",
  "overview.openAnomalies": "Apri l'elenco",
  "overview.anomaliesLine": "{waiting} da decidere · {decided} decise",
  "overview.activity": "Attività",
  "overview.noEvents": "Nessun evento recente su questa commessa.",
  "overview.openAudit": "Apri il giornale",
  "overview.auditNeeds": "Il giornale completo lo legge {who}.",
  "overview.phaseFailed": "Fase {phase} fallita",
  "overview.conflictOne": "1 conflitto",
  "overview.conflicts": "{n} conflitti",
  "overview.gapOne": "1 buco di copertura",
  "overview.gapsCount": "{n} buchi di copertura",
  "overview.invalidOne": "1 finding non valido",
  "overview.invalids": "{n} finding non validi",
  "overview.sessionOne": "1 sessione viva",
  "overview.sessions": "{n} sessioni vive",
  "overview.leaseOne": "1 candidato in mano",
  "overview.leases": "{n} candidati in mano",
  "overview.intentOne": "1 verdetto in volo",
  "overview.intents": "{n} verdetti in volo",
  "overview.resumeIngest": "Riprendi ingest",
  "overview.openConflicts": "Apri i conflitti",
  "overview.openGaps": "Apri i buchi di copertura",
  "overview.openInvalid": "Apri i finding non validi",
  "overview.freezeBase": "Congela la base",
  "overview.openSample": "Apri il campione",
  "overview.openQuality": "Apri il quality gate",
  "overview.openDelivery": "Apri la consegna",
  "overview.acqState": "Acquisizione {state}.",
  "overview.acqStatePhase": "Acquisizione {state} · {phase}.",
  "overview.ingestMissingLink": "Ingest da riprendere, ma manca il collegamento al job o alla ricevuta. Serve ingest.retry o upload.receipt.read.",
  "overview.reasonConflicts": "Restano conflitti da chiudere prima di congelare.",
  "overview.reasonGaps": "Restano buchi di copertura da dichiarare o coprire.",
  "overview.reasonInvalid": "Restano finding non validi: il congelamento è bloccato.",
  "overview.reasonLive": "Qualcuno sta ancora lavorando qui — sessioni aperte, candidati in mano o verdetti in volo: il congelamento aspetta che finiscano.",
  "overview.reasonOpen": "La base di verifica è ancora aperta.",
  "overview.reasonSample": "Il campione manca o non è completo.",
  "overview.reasonSeal": "Manca un sigillo valido.",
  "overview.reasonCompose": "Il sigillo è valido: si può comporre la consegna.",
  "overview.reasonWaiting": "{n} candidati in attesa.",
  "overview.reasonOthers": "Da qui non si sblocca: serve {who}.",
  "overview.reasonHeld": "Il lavoro è in carico ad altri.",
  "overview.reasonBlocks": "Restano blocchi da chiudere prima di congelare.",
  "coverage.statusCovered": "coperto",
  "coverage.statusDeclared": "non ispezionato",
  "coverage.statusGap": "scoperto",
  "coverage.legend": "Legenda dei segni",
  "coverage.meaningCovered": "qualcuno ha guardato un fotogramma che inquadra l'elemento, o ha scritto un'anomalia",
  "coverage.meaningDeclared": "dichiarato non ispezionabile, con il motivo scritto: la consegna lo può spiegare",
  "coverage.meaningGap": "ne visto ne dichiarato: la consegna si ferma qui",
  "coverage.deliveryPending": "in consegna",
  "coverage.deliveryApplied": "registrata",
  "coverage.deliveryWithdrawn": "ritirata",
  "coverage.deliveryRejected": "respinta",
  "coverage.deliveryStale": "da rifare",
  "coverage.meaningPending": "dichiarata e messa al sicuro, non ancora registrata dal servizio",
  "coverage.meaningApplied": "il servizio ha scritto la dichiarazione",
  "coverage.meaningWithdrawn": "la dichiarazione e stata annullata",
  "coverage.meaningRejected": "il servizio non ha registrato la dichiarazione: va ripresa",
  "coverage.meaningStale": "lo stato su cui poggiava e cambiato: va ripresa sull'attuale",
  "coverage.reviewed": "revisionato",
  "coverage.toReview": "da revisionare",
  "coverage.meaningReviewed": "qualcuno ha dichiarato di aver guardato questo fotogramma",
  "coverage.meaningToReview": "nessuno ha dichiarato di averlo guardato",
  "coverage.noSession": "Nessuna sessione di verifica su questa commessa: si può guardare la copertura, non dichiararla. Torna online e riapri il modulo.",
  "coverage.reviewedDeclared": "{filename}: dichiarato revisionato, in consegna.",
  "coverage.reviewedWithdrawn": "{filename}: revisione ritirata, in consegna.",
  "coverage.gapDeclared": "Elemento {id}: dichiarato non ispezionato, in consegna.",
  "coverage.gapWithdrawn": "Elemento {id}: dichiarazione ritirata, in consegna.",
  "coverage.codeRequired": "Il codice dell'anomalia è obbligatorio.",
  "coverage.findingQueued": "Anomalia {code} livello {level} su elemento {id}: in consegna.",
  "coverage.heading": "Copertura della commessa",
  "coverage.filterAll": "Tutti",
  "coverage.search": "Cerca per numero dell'elemento",
  "coverage.openMap": "Apri la mappa",
  "coverage.openPhotos": "Apri le foto che lo inquadrano",
  "coverage.deliveryState": "Stato della consegna",
  "coverage.reading": "Lettura della copertura…",
  "coverage.noneBlocking": "Nessun elemento scoperto su {total}: la copertura non blocca la consegna.",
  "coverage.blockingOne": "{n} elemento scoperto su {total}: la consegna resta bloccata finché non sono visti o dichiarati.",
  "coverage.blockingMany": "{n} elementi scoperti su {total}: la consegna resta bloccata finché non sono visti o dichiarati.",
  "coverage.statsCoveredOne": "{n} coperto",
  "coverage.statsCoveredMany": "{n} coperti",
  "coverage.statsDeclaredOne": "{n} dichiarato non ispezionato",
  "coverage.statsDeclaredMany": "{n} dichiarati non ispezionati",
  "coverage.statsPending": "{n} in consegna",
  "coverage.statsRejectedOne": "{n} respinta",
  "coverage.statsRejectedMany": "{n} respinte",
  "coverage.offline": "Fuori linea: le dichiarazioni restano in coda",
  "coverage.nothingToSend": "niente da consegnare",
  "coverage.toSend": "{n} da consegnare",
  "coverage.noSessionShort": "nessuna sessione di verifica",
  "coverage.sessionOpen": "sessione di verifica aperta",
  "coverage.ribbon": "Nastro della copertura",
  "coverage.elementStatus": "Elemento {id}: {status}",
  "coverage.noElements": "Nessun elemento nell'anagrafica.",
  "coverage.filters": "Filtri dei fotogrammi",
  "coverage.filtersTitle": "Filtri",
  "coverage.filterReview": "Revisione",
  "coverage.allFrames": "Tutti i fotogrammi",
  "coverage.onlyReviewed": "Solo revisionati",
  "coverage.onlyUnreviewed": "Solo da revisionare",
  "coverage.filterCandidates": "Candidati del modello",
  "coverage.onlyWithout": "Solo senza candidati",
  "coverage.onlyWith": "Solo con candidati",
  "coverage.filterCamera": "Fotocamera",
  "coverage.filterQuality": "Qualità: dettaglio a terra massimo, in mm per pixel",
  "coverage.rowsPerPage": "Righe per pagina",
  "coverage.clearFilters": "Togli i filtri",
  "coverage.map": "Mappa della copertura",
  "coverage.mapTitle": "Mappa",
  "coverage.noCoords": "Nessun elemento con coordinate: la copertura si legge nell'elenco qui accanto.",
  "coverage.mapWith": "Mappa con {n} elementi della rete",
  "coverage.feature": "Elemento {id}, {type}: {status}",
  'lineMap.title': 'Mappa della linea',
  'lineMap.reading': 'Leggo la linea\u2026',
  'lineMap.unreachable': 'Il servizio non risponde: la mappa della linea non si disegna.',
  'lineMap.empty': "Nessuna geometria: la mappa si disegna quando l'anagrafica ha coordinate.",
  'lineMap.summary': '{poles} elementi \u00b7 {marks} anomalie con posizione \u00b7 volo con {points} punti',
  'lineMap.with': 'Mappa della linea con {poles} elementi e {marks} anomalie',
  'lineMap.pole': 'Elemento {id}, {type}: {status}',
  'lineMap.worst': 'peggiore {rank}',
  'lineMap.mark': 'Candidato {code}, {rank}',
  'lineMap.violation': 'violazione di distanza',
  'lineMap.legendViolation': 'Violazione di distanza misurata dal LiDAR',
  'lineMap.legendCluster': 'Anomalie vicine raggruppate: il numero dice quante, il bordo la peggiore; si clicca per avvicinarsi',
  'lineMap.cluster': '{n} anomalie raggruppate, peggiore {rank}',
  'map.scale': 'Scala: {length}',
  'lineMap.legendPole': 'Sostegno o campata coperti; il bordo prende il tono del livello peggiore',
  'lineMap.legendGap': 'Sostegno o campata senza copertura',
  'lineMap.legendSpan': 'Asse della linea',
  'lineMap.legendFlight': 'Traiettoria del volo',
  "coverage.list": "Elenco degli elementi",
  "coverage.networkElements": "Elementi della rete",
  "coverage.colElement": "Elemento",
  "coverage.colType": "Tipo",
  "coverage.colStatus": "Stato",
  "coverage.colFrames": "Fotogrammi",
  "coverage.colDeclaration": "Dichiarazione",
  "coverage.colAction": "Azione",
  "coverage.framesReviewed": "{frames} · {reviewed} revisionati · {findings} anomalie",
  "coverage.chooseElement": "Scegli elemento {id}",
  "coverage.noElementsShow": "Nessun elemento da mostrare.",
  "coverage.frames": "Fotogrammi",
  "coverage.readingFrames": "Lettura dei fotogrammi…",
  "coverage.noFramesFiltered": "Nessun fotogramma con questi filtri: togline uno per allargare la ricerca.",
  "coverage.noFrames": "Nessun fotogramma in questa commessa.",
  "coverage.framesPage": "{total} fotogrammi · pagina da {from} a {to}",
  "coverage.colFrame": "Fotogramma",
  "coverage.colReview": "Revisione",
  "coverage.colCandidates": "Candidati",
  "coverage.colCamera": "Fotocamera",
  "coverage.colQuality": "Qualità",
  "coverage.colActions": "Azioni",
  "coverage.unknownCamera": "ignota",
  "coverage.unmeasured": "non misurata",
  "coverage.chooseFrame": "Scegli {filename}",
  "coverage.withdrawReview": "Ritira la revisione",
  "coverage.declareReviewed": "Dichiara revisionato",
  "coverage.subject": "Soggetto scelto",
  "coverage.gapTitle": "Elemento non ispezionato",
  "coverage.overview": "La copertura",
  "coverage.framesLine": "{frames} scattati · {reviewed} guardati · {findings} anomalie",
  "coverage.pickHint": "Scegli un elemento nell'elenco o sulla linea per dichiarare o ritirare.",
  "coverage.gapPick": "Scegli un elemento nell'elenco per dichiararlo non ispezionato o ritirare la dichiarazione.",
  "coverage.elementLine": "Elemento {id} ({type})",
  "coverage.writtenReason": "Motivo scritto: {reason}",
  "coverage.withdrawGap": "Ritira la dichiarazione dell'elemento {id}",
  "coverage.reason": "Motivo",
  "coverage.noteOptional": "Nota (facoltativa)",
  "coverage.declareGap": "Dichiara l'elemento {id} non ispezionato",
  "coverage.manualTitle": "Anomalia trovata a mano",
  "coverage.manualPick": "Scegli un elemento e un fotogramma che lo inquadra: un'anomalia si dichiara sempre su un elemento della rete, mai su un fotogramma da solo.",
  "coverage.frameNotOnElement": "Il fotogramma {filename} non inquadra l'elemento {id}: filtra i fotogrammi per quell'elemento e scegline uno.",
  "coverage.altFrame": "Fotogramma {filename}",
  "coverage.altThumb": "Miniatura del fotogramma {filename}",
  "coverage.noImage": "Nessuna immagine disponibile: il riquadro si compone con i quattro campi.",
  "coverage.boxLegend": "Riquadro, in pixel del fotogramma",
  "coverage.boxX": "X (da sinistra)",
  "coverage.boxY": "Y (dall'alto)",
  "coverage.boxWidth": "Larghezza",
  "coverage.boxHeight": "Altezza",
  "coverage.frameSize": "Il fotogramma misura {width}×{height} px.",
  "coverage.frameSizeUnknown": "La misura del fotogramma non è nota: il servizio ricontrolla i limiti.",
  "coverage.code": "Codice",
  "coverage.noCodes": "Nessun codice ammesso per questo elemento",
  "coverage.level": "Livello",
  "coverage.record": "Registra l'anomalia",
  "coverage.recordNote": "Registrata come trovata dall'operatore, già confermata, con la sua storia.",
  "coverage.picked": "{filename} · elemento {id} ({type})",
  "search.unread": "Non è stato possibile sfogliare i fotogrammi",
  "search.framesStatus": "{n} fotogrammi · {queue}",
  "search.openCoverage": "Apri la copertura della commessa",
  "search.noFrames": "Nessun fotogramma da mostrare.",
  "search.noPyramid": "{filename}: la piramide non è disponibile. Il riquadro si compone con i quattro campi.",
  "search.foundTitle": "Anomalia trovata",
  "search.element": "Elemento della rete",
  "search.noFramed": "Nessun elemento inquadrato da questo fotogramma",
  "search.drawHint": "Premi B (o ▭ sulla tela) e traccia il riquadro trascinando sul fotogramma, oppure batti i quattro numeri.",
  "search.elementRequired": "L'elemento della rete è obbligatorio: un'anomalia si dichiara su una campata.",
  "search.notFramed": "Il fotogramma non inquadra questo elemento: scegline uno visibile nello scatto.",
  "search.noSession": "Nessuna sessione di verifica su questa commessa: si può guardare, non dichiarare.",
  "search.findingQueued": "Anomalia {code} livello {level} su {filename}: in consegna.",
  "photos.search": "Cerca per nome del file",
  "photos.cameraAll": "Tutte",
  "photos.onlyUnreviewed": "Solo non revisionati",
  "photos.onlyUntouched": "Solo senza candidati",
  "photos.count": "{shown} di {total} fotogrammi",
  "photos.loadMore": "Mostra altri {n}",
  "photos.list": "Fotogrammi",
  "photos.chooseFrame": "Scegli un fotogramma a sinistra.",
  "photos.frame": "Fotogramma",
  "photos.camera": "Camera",
  "photos.taken": "Scattato",
  "photos.size": "Dimensioni",
  "photos.quality": "Dettaglio a terra",
  "photos.elements": "Elementi inquadrati",
  'photos.takenFromFilename': 'dal nome del file',
  'photos.takenFromAlignment': 'dal file delle pose',
  'photos.takenUnknown': "nessun istante: né EXIF, né posa, né nome",
  'photos.qualityFromAnomaly': "dall'anomalia inquadrata",
  'photos.qualityFromSpan': 'dalla campata rilevata',
  'photos.qualityFromElement': "dall'anagrafica, in pianta",
  'photos.qualityNoPose': 'senza posa: non misurabile',
  'photos.qualityNoSubject': 'nessun soggetto a distanza nota',
  "photos.findings": "Anomalie su questo fotogramma",
  "photos.noFindings": "Nessuna anomalia su questo fotogramma.",
  "photos.waiting": "da decidere",
  "photos.confirmed": "confermata {rank}",
  "photos.rejected": "respinta",
  "photos.openDesk": "Apri nel banco",
  "photos.onMap": "sulla mappa",
  "photos.extent": "Sul terreno: {size}",
  "photos.extentUnknown": "Sul terreno: non si misura, il fotogramma non ha un dettaglio a terra.",
  "photos.framesOfElement": "tutti i suoi fotogrammi",
  "photos.declare": "Dichiara un'anomalia",
  "photos.canvasHint": "Trascina per spostare · rotella per ingrandire · B per il riquadro",
  "photos.reviewed": "revisionato",
  "photos.detail": "Scheda del fotogramma",
  "progress.short": "Avanzamento",
  "progress.reading": "Lettura dell'avanzamento…",
  "progress.offlineNote": "Offline, sola lettura: ultimo snapshot {when}. Non si decide da qui.",
  "progress.offlineBare": "Offline, sola lettura. Non si decide da qui.",
  "progress.manual": "manuali",
  "progress.gaps": "buchi di copertura",
  "progress.sessions": "sessioni vive",
  "progress.leases": "candidati in mano",
  "progress.intents": "verdetti in volo",
  "progress.conflicts": "conflitti",
  "progress.invalid": "finding non validi",
  "progress.byLevel": "per livello",
  "progress.frozen": "Base congelata",
  "progress.open": "Base aperta",
  "progress.sealValid": " · sigillo valido",
  "progress.freezeBlocks": " · {n} blocchi al congelamento",
  "progress.resume": "Riprendi",
  "progress.openQuality": "Apri qualità",
  "quality.actionFailed": "Azione non riuscita.",
  "quality.freezeRemain": "{message} Restano: {parts}.",
  "quality.blockerSessions": "sessioni vive",
  "quality.blockerLeases": "candidati ancora in mano",
  "quality.blockerIntents": "verdetti ancora in volo",
  "quality.blockerConflicts": "conflitti",
  "quality.blockerInvalid": "trovate non valide",
  "quality.loadFailed": "Lettura non riuscita.",
  "quality.offline": "Offline, sola lettura: congelamento, campione, revisione, sigillo e riapertura sono chiusi.",
  "quality.reading": "Lettura del controllo di qualità…",
  "quality.freeze": "Congelamento",
  "quality.wasEpoch": " · era {epoch} · versione {version}",
  "quality.sampleAfter": ": il campione nasce solo dopo il congelamento.",
  "quality.freezing": "Congelamento in corso…",
  "quality.freezeBase": "Congela la base",
  "quality.sample": "Campione",
  "quality.sampleMeta": "{n} casi · algoritmo {algo} · seed {seed}",
  "quality.noSample": "Nessun campione. Si genera dalla sola base congelata.",
  "quality.sampling": "Campionamento in corso…",
  "quality.generateSample": "Genera campione",
  "quality.secondary": "Revisione secondaria",
  "quality.needSample": "Prima il campione, poi il ricontrollo.",
  "quality.sampleIntro": "I casi estratti dalla base congelata, da ricontrollare uno per uno: si apre nel banco, si conferma o si ribalta. Congelamento, campione e sigillo si governano dalla consegna.",
  "quality.openDelivery": "Apri la consegna",
  "quality.allReviewed": "Tutti i casi sono ricontrollati.",
  "quality.caseElement": "elemento {n}",
  "quality.confirm": "Conferma",
  "quality.overturn": "Ribalta",
  "quality.reviewing": "Revisione secondaria in corso…",
  "quality.seal": "Sigillo",
  "quality.sealValid": "Sigillo valido · era {epoch} · congelamento {freeze} · supervisore {supervisor}",
  "quality.noSeal": "Nessun sigillo valido.",
  "quality.sealing": "Sigillo in corso…",
  "quality.applySeal": "Applica il sigillo",
  "quality.unfreeze": "Riapertura",
  "quality.unfreezeAction": "Riapri la verifica",
  "quality.unfreezeHint": "Riapre la verifica ordinaria e invalida sigillo e bozze di consegna.",
  "quality.unfreezing": "Scongelamento in corso…",
  "delivery.offline": "Offline: nessuna mutazione della consegna.",
  "delivery.reading": "Lettura dello stato della consegna…",
  "delivery.done": "fatto",
  "delivery.now": "tocca adesso",
  "delivery.later": "dopo",
  "delivery.step.review": "Verifica completa",
  "delivery.step.freeze": "Base di verifica congelata",
  "delivery.step.sample": "Campione di qualità ricontrollato",
  "delivery.step.seal": "Sigillo di qualità",
  "delivery.step.privacy": "Fotogrammi anonimizzati",
  "delivery.parallel": "in parallelo alle altre tappe",
  "delivery.privacyLine": "guardati {n} di {total} fotogrammi",
  "delivery.privacyPending": "La scansione è partita: i conti salgono mentre il lavoratore macina.",
  "delivery.scan": "Avvia la scansione",
  "delivery.rescan": "Ripeti la scansione",
  "delivery.step.package": "Pacchetto composto",
  "delivery.step.validate": "Pacchetto validato",
  "delivery.step.send": "Invio registrato",
  "delivery.step.receipt": "Ricevuta permanente",
  "delivery.reviewLine": "{waiting} da decidere · {decided} decise",
  "delivery.conflicts": "{n} conflitti",
  "delivery.gaps": "{n} buchi di copertura",
  "delivery.openAnomalies": "Apri le anomalie da decidere",
  "delivery.openCoverage": "Apri la copertura",
  "delivery.openReport": "Apri il rapporto da stampare",
  "delivery.reportNote": "Si stampa dal navigatore (Stampa → PDF); le miniature valgono quindici minuti.",
  "delivery.frozenLine": "congelata: epoch {epoch} · versione {freeze} / {supervisor}",
  "delivery.notFrozen": "La verifica è aperta: si congela quando non c'è più niente da decidere.",
  "delivery.freeze": "Congela la base di verifica",
  "delivery.unfreeze": "Riapri la verifica (invalida il sigillo)",
  "delivery.noSample": "Nessun campione: si estrae dalla base congelata.",
  "delivery.sampleLine": "{reviewed} di {required} casi ricontrollati",
  "delivery.createSample": "Estrai il campione",
  "delivery.reviewSample": "Ricontrolla il campione",
  "delivery.noSealYet": "Nessun sigillo: si fissa a campione ricontrollato.",
  "delivery.applySeal": "Fissa il sigillo",
  "delivery.noPackage": "Nessun pacchetto composto.",
  "delivery.packageWithdrawn": "Il pacchetto composto non vale più: la base è cambiata dopo. Va ricomposto.",
  "delivery.recompose": "Ricomponi il pacchetto",
  "delivery.showPackage": "Che cosa contiene il pacchetto",
  "delivery.validated": "Validato: il contenuto è quello che parte.",
  "delivery.notValidated": "Si valida a pacchetto composto senza errori.",
  "delivery.sentLine": "Inviata da {who}.",
  "delivery.notSent": "Si registra l'invio a pacchetto validato.",
  "delivery.noReceipt": "La ricevuta nasce con l'invio.",
  "delivery.compose": "Componi il pacchetto",
  "delivery.whatLeft": "Che cosa è partito",
  "delivery.validate": "Valida",
  "delivery.closedBy": "L'invio resta chiuso finché restano {n} punti bloccanti.",
  "delivery.warningsOpen": "{n} avvisi restano aperti: l'invio passa, ma la motivazione parte con la consegna.",
  "delivery.noIssues": "Nessun rilievo aperto.",
  "delivery.whyWarnings": "Perché si invia con gli avvisi aperti",
  "delivery.registerSend": "Registra invio",
  "delivery.undeliverable": "{n} anomalie confermate non sono consegnabili: manca l'elemento della rete o il fotogramma.",
  "delivery.errorsTitle": "Errori: impediscono l'invio",
  "delivery.warningsTitle": "Avvisi: non impediscono l'invio",
  "delivery.declarations": "dichiarazioni",
  "delivery.operator": "operatore",
  "delivery.catalog": "catalogo",
  "delivery.sha256": "sha-256",
  "delivery.prepareDoc": "Prepara il documento come è partito",
  "delivery.downloadDoc": "Scarica il documento come è partito",
  "delivery.openReceipt": "Apri la ricevuta permanente",
  "delivery.sentWithWarnings": "Inviata con avvisi aperti: ",
  "delivery.rejected": "Respinta: {reason}",
  "delivery.stateIssues": "stato {state} · {n} anomalie · catalogo {catalog}",
  "delivery.checksum": "impronta {checksum}…",
  "delivery.redo": " · rifà una consegna respinta",
  "delivery.sealLine": "sigillo epoch {epoch} · versione {freeze} / {supervisor}",
  "delivery.contents": "Contenuto: {n} dichiarazioni",
  "delivery.emptyContents": "Nessuna dichiarazione: la consegna dichiara un lavoro senza criticità.",
  "delivery.colElement": "Elemento",
  "delivery.colType": "Tipo",
  "delivery.colCode": "Codice",
  "delivery.colLevel": "Livello",
  "delivery.colImages": "Immagini",
  "purpose.what": "Che cosa si fa qui",
  "purpose.upload": "Porti un pacchetto di rilievo dentro la piattaforma: scegli la cartella, e prima di ricevere un byte ti dice se manca qualcosa.",
  "purpose.receipt": "La ricevuta del caricamento: che cosa è entrato, che cosa è stato messo da parte, e da qui si segue l'acquisizione.",
  "purpose.ingest": "L'acquisizione del pacchetto, fase per fase: una fase ferma si riprende da qui, e quando l'ultima è fatta la commessa è pronta al lavoro.",
  "purpose.work": "Le commesse: qui si sceglie su quale lavorare, e si vede a che punto è ciascuna.",
  "purpose.overview": "La commessa a colpo d'occhio: dov'è nel suo ciclo, che cosa la ferma, e il passo successivo — è il posto a cui si torna.",
  "purpose.map": "La linea sulla mappa: gli elementi col loro stato, per vedere dove sono i problemi e da dove è passato il volo.",
  "purpose.anomalies": "Le anomalie decise su questa commessa, filtrabili per stato e rango: ciò che la consegna dichiarerà.",
  "purpose.queue": "Il banco: la coda porta i candidati uno per uno, e qui si dà il verdetto — coi tasti, senza cercare.",
  "purpose.search": "La ricerca libera nei fotogrammi: per trovare ciò che il modello non ha visto e scriverlo come anomalia.",
  "purpose.coverage": "Che cosa è stato visto e che cosa no: i buchi si dichiarano qui con il loro motivo, altrimenti la consegna si ferma.",
  "purpose.element": "La scheda di un elemento della rete: i fotogrammi che lo inquadrano e le anomalie che lo riguardano.",
  "purpose.progress": "L'avanzamento della commessa: quanti candidati aspettano, quanti sono decisi, e che cosa la tiene ancora aperta.",
  "purpose.quality": "Il cancello di qualità: si congela il lavoro, si ricontrolla un campione, e si appone il sigillo che permette la consegna.",
  "purpose.delivery": "La consegna al committente: si compone il documento, lo si verifica, lo si invia e si registra l'esito.",
  "purpose.deliveries": "Tutte le consegne inviate, con il loro esito: quali sono accettate, quali respinte, quali aspettano.",
  "purpose.deliveryReceipt": "La ricevuta di una consegna: che cosa è stato inviato, quando, e che cosa ha risposto il committente.",
  "purpose.operations": "L'esercizio dell'installazione: copie, spazio, sentinella — ciò che la sentinella vede lo vedi anche tu.",
  "purpose.users": "Le utenze e i loro mestieri: chi entra, con quale ruolo, e chi non entra più.",
  "purpose.model": "Il modello che propone i candidati: quale edizione è in uso, come si misura, e quando cambiarla.",
  "purpose.settings": "Le regole della decisione e della consegna: ogni cambio è una decisione registrata, con chi e perché.",
  "purpose.catalog": "Il catalogo delle anomalie: le edizioni, quale è in uso, e come se ne carica una nuova.",
  "purpose.audit": "Il giornale: ogni azione registrata, di chi e quando — la traccia per capire che cosa è successo.",
  "start.here": "Da dove si comincia",
  "aiuto.manual": "Manuale",
  "aiuto.sections": "Sezioni dell'aiuto",
  "aiuto.manualIntro": "Come si lavora, per mestiere: il tuo capitolo è aperto, gli altri stanno sotto, chiusi — servono per capire chi riceve il tuo lavoro.",
  "aiuto.manualLanguage": "Il manuale è in italiano, la lingua di chi lavora sulle linee.",
  "aiuto.chapters": "I capitoli",
  "aiuto.otherChapters": "Gli altri mestieri",
  "aiuto.keysIntro": "I tasti del banco, mano per mano. Nel banco la stessa mappa si apre col tasto «?» o dal comando in testa.",
  "start.help": "Il manuale del tuo mestiere, le parole del prodotto e i tasti stanno sotto",
  "start.rail": "Nella barra a sinistra ci sono i moduli del tuo ruolo: chi fa un altro mestiere ne vede altri.",
  "start.uploader": "Porti i pacchetti di rilievo dentro la piattaforma. Scegli la cartella, non i singoli file: viene letta prima di ricevere un solo byte, e se manca qualcosa te lo dice subito invece che fra due ore. Dopo il caricamento l'acquisizione va da sola in nove fasi; se una si ferma, la schermata dice quale e perché, e rilanciare non duplica niente.",
  "start.qa": "Giudichi i candidati: la coda te li porta uno per uno, non li cerchi tu. La giornata comincia prendendo una commessa dall'elenco; se l'elenco è vuoto, adesso non c'è niente da giudicare. La consegna al committente non è tua — la firma chi se ne assume il contenuto.",
  "start.supervisor": "Giudichi come gli operatori, e in più chiudi il lavoro: congeli, ricontrolli il campione sorteggiato, apponi il sigillo e firmi la consegna. Comincia da una commessa dell'elenco; se non ha candidati, il tuo lavoro è il cancello di qualità.",
  "start.manager": "Tieni in piedi ciò che permette agli altri di lavorare: utenze e ruoli, catalogo dei codici, decisioni prese in attesa del committente, modello, giornale. Non giudichi candidati e non consegni: amministrare non è essere stati formati per giudicare un'anomalia.",
  "start.hypotheses": "{n} decisioni sono ancora nostre ipotesi: aspettano una risposta del committente.",
  "start.hypothesesNone": "Nessuna decisione aperta: tutte hanno una norma o una risposta dietro.",
  "start.toSettings": "Guarda le decisioni",
  "workspace.map": "Mappa",
  "workspace.photos": "Foto",
  "workspace.anomalies": "Anomalie",
  "workspace.delivery": "Consegna",
  "workspace.more": "Altro",
  "workspace.toReview": "{n} da verificare",
  "workspace.decided": "{n} decisi",
  "map.title": "Mappa della commessa",
  "map.elements": "Elementi",
  "map.search": "Cerca un elemento",
  "map.kind": "Tipo di elemento",
  "map.kindAll": "Tutti",
  "map.layers": "Livelli",
  "map.layerPoles": "Sostegni",
  "map.layerSpans": "Campate",
  "map.layerFlight": "Volo",
  "map.layerPhotos": "Foto",
  "map.layerMarks": "Anomalie",
  "map.summary": "{poles} elementi · {photos} foto · {marks} anomalie con posizione",
  "map.noneMatch": "Nessun elemento corrisponde: allarga il filtro, o toglilo.",
  "map.zoom": "Zoom",
  "map.zoomIn": "Avvicina",
  "map.zoomOut": "Allontana",
  "map.fit": "Tutta la linea",
  "map.detail": "Dettaglio",
  "map.hint": "Scegli un sostegno, una foto o un'anomalia sulla mappa o nell'elenco.",
  "map.close": "Chiudi",
  "map.coverage": "Copertura",
  "map.frames": "Fotogrammi",
  "map.framesOf": "{n} lo inquadrano · {reviewed} guardati · {candidates} con candidati",
  "map.findings": "Anomalie",
  "map.coordinates": "Coordinate",
  "map.openElement": "Apri la scheda dell'elemento",
  "map.openQueue": "Apri i candidati nel banco",
  "map.openCoverage": "Apri la copertura",
  "map.rank": "Rango",
  "map.source": "Origine",
  "map.verdict": "Verdetto",
  "map.confirmed": "confermata",
  "map.waiting": "in attesa",
  "map.margin": "Margine",
  "map.openCandidate": "Apri nel banco",
  "map.photo": "Foto",
  "map.file": "File",
  "map.camera": "Camera",
  "map.openPhotos": "Sfoglia i fotogrammi",
  "map.openFrame": "Apri questo fotogramma",
  "map.framesOfElement": "Tutti i suoi fotogrammi",
  "map.thumbs": "Fotogrammi che lo inquadrano",
  "map.marksOf": "Anomalie su questo elemento",
  "map.legendPhoto": "Scatto",
  "map.ground": "Sfondo",
  "map.groundNone": "Nessuno",
  "map.groundMap": "Carta",
  "map.groundSatellite": "Satellite",
  "title.map": "Mappa",
  "title.anomalies": "Anomalie",
  "anomalies.list": "Elenco delle anomalie",
  "anomalies.detail": "Scheda dell'anomalia",
  "anomalies.unread": "Non è stato possibile leggere le anomalie",
  "anomalies.status": "Stato",
  "anomalies.all": "Tutte",
  "anomalies.waiting": "Da decidere",
  "anomalies.confirmed": "Confermate",
  "anomalies.rejected": "Respinte",
  "anomalies.rank": "Rango",
  "anomalies.anyRank": "Ogni rango",
  "anomalies.search": "Cerca per codice, sostegno o fotogramma",
  "anomalies.count": "{shown} di {total} anomalie",
  "anomalies.loadMore": "Mostra altre {n}",
  "anomalies.none": "Nessuna anomalia qui",
  "anomalies.noneFiltered": "Con questi filtri non resta niente: allargali, o toglili.",
  "anomalies.noneAtAll": "Le anomalie nascono dai verdetti: finché nessuno decide un candidato, questa tabella resta vuota.",
  "anomalies.clearFilters": "Togli i filtri",
  "anomalies.colRank": "Rango",
  "anomalies.colWhat": "Anomalia",
  "anomalies.colElement": "Elemento",
  "anomalies.colFrame": "Fotogramma",
  "anomalies.colState": "Stato",
  "anomalies.noFrame": "senza fotogramma",
  "anomalies.stateWaiting": "da decidere",
  "anomalies.stateConfirmed": "confermata {rank}",
  "anomalies.stateRejected": "respinta",
  "anomalies.decidedBy": "da {who}, {when}",
  "anomalies.history": "Storia",
  "anomalies.overview": "La commessa",
  "anomalies.colMargin": "Margine",
  "anomalies.colWho": "Chi · quando",
  "anomalies.noElement": "senza elemento",
  "anomalies.stateConfirmedShort": "confermate",
  "anomalies.framesWith": "Fotogrammi con anomalie",
  "anomalies.batch": "Pacchetto",
  "anomalies.tick": "Spunta {code}",
  "anomalies.ticked": "{n} spuntate",
  "anomalies.batchReason": "Motivo del rifiuto",
  "anomalies.rejectTicked": "Respingi {n} con questo motivo",
  "anomalies.untick": "togli le spunte",
  "anomalies.batchDone": "{n} respinte",
  "anomalies.batchSkipped": "{n} saltate: già decise o in mano ad altri",
  "anomalies.batchUndo": "Annulla",
  "anomalies.someone": "qualcuno",
  "anomalies.eventPredicted": "proposta dal modello, {rank}",
  "anomalies.eventDeclared": "dichiarata a mano, {rank}",
  "anomalies.eventMeasured": "misurata dalla nuvola, {rank}",
  "anomalies.eventConfirmed": "confermata {rank} da {who}",
  "anomalies.eventConfirmedCorrected": "confermata {rank} da {who}, riquadro ridisegnato",
  "anomalies.eventRejected": "respinta da {who}: {reason}",
  "anomalies.eventWithdrawn": "verdetto ritirato da {who}: torna in coda",
  "anomalies.proposed": "(proposto {rank})",
  "anomalies.source": "Sorgente",
  "anomalies.notExportable": "Senza fotogramma la consegna non la esporterà.",
  "anomalies.decide": "Decidi nel banco",
  "anomalies.openDesk": "Apri nel banco",
  "anomalies.openElement": "Apri la scheda dell'elemento",
  "anomalies.openPhoto": "Apri il fotogramma fra le foto",
  "anomalies.chooseRow": "Scegli un'anomalia nell'elenco.",
  "figures.title": "Le cifre",
  "figures.period": "Periodo",
  "figures.week": "Settimana",
  "figures.month": "Mese",
  "figures.all": "Tutta la commessa",
  "figures.reading": "Lettura delle cifre…",
  "figures.unreachable": "Le cifre non si leggono adesso: il servizio non risponde.",
  "figures.computedAt": "Calcolate il {when}. Le tappe sono una fotografia di adesso; anomalie e consegne contano nel periodo.",
  "figures.packages": "Pacchetti per tappa",
  "figures.nonePackages": "Nessun pacchetto.",
  "figures.acquiring": "in acquisizione",
  "figures.failed": "acquisizione ferma",
  "figures.inReview": "in verifica",
  "figures.awaitingGate": "aspettano il cancello di qualità",
  "figures.sealed": "sigillati, da consegnare",
  "figures.delivered": "consegnati, in attesa d'esito",
  "figures.accepted": "accettati dal committente",
  "figures.rejected": "respinti dal committente",
  "figures.findings": "Anomalie dichiarate nel periodo",
  "figures.noneFindings": "Nessuna anomalia dichiarata nel periodo.",
  "figures.total": "in tutto",
  "figures.deliveries": "Consegne nel periodo",
  "figures.noneDeliveries": "Nessuna consegna partita nel periodo.",
  "figures.submitted": "partite",
  "figures.withReceipt": "con ricevuta",
  "figures.acceptedDeliveries": "accettate",
  "figures.rejectedDeliveries": "respinte",
  "figures.behind": "I pacchetti dietro la cifra",
  "role.does.upload": "porta i pacchetti di rilievo nella piattaforma",
  "role.does.review": "giudica i candidati e registra trovate a mano",
  "role.does.quality": "congela il lavoro, ricontrolla il campione, appone il sigillo",
  "role.does.deliver": "compone e invia la consegna al committente",
  "role.does.admin": "amministra utenze, catalogo, decisioni, modello e giornale",
  "role.not.upload": "non carica pacchetti",
  "role.not.review": "non giudica candidati",
  "role.not.quality": "non sigilla",
  "role.not.deliver": "non consegna",
  "role.not.admin": "non amministra",
  "role.doesIntro": "Con questo ruolo",
  "role.notIntro": "e",
  "users.chooseRole": "Scegli un ruolo",
  "users.roleFirst": "Il ruolo va scelto: nessuno è preimpostato, perché un valore predefinito è il modo di aprire un supervisore senza averci pensato.",
  "concept.critical.term": "Decisione critica",
  "concept.critical.says": "Pesa su ciò che si consegna o su ciò che l'operatore vede. Cambiarla richiede di scrivere il perché: fra sei mesi una consegna passata con una soglia diversa da quella di oggi si spiega solo con quella riga.",
  "upload.zoneTitle": "Scegli la cartella del rilievo",
  "upload.zoneHint": "La cartella intera, non i singoli file. Viene letta prima di ricevere un solo byte: se manca qualcosa lo sai subito. Puoi anche trascinarla qui.",
  "upload.zoneButton": "Scegli la cartella",
  "upload.recognisedAs": "{name} — {cameras}, {clouds}, {trajectory}",
  "upload.camerasNone": "nessuna camera",
  "upload.camerasOne": "una camera da {frames} scatti",
  "upload.camerasMany": "{n} camere da {frames} scatti",
  "upload.cloudsNone": "nessuna nuvola",
  "upload.cloudsOne": "una nuvola",
  "upload.cloudsMany": "{n} nuvole",
  "upload.trajectoryYes": "traiettoria presente",
  "upload.trajectoryNo": "traiettoria assente",
  "upload.cannotIntro": "Così non si carica. Prima di riprovare:",
  "title.glossary": "Glossario",
  "chrome.glossary": "Glossario",
  "glossary.intro": "Le parole del prodotto, nell'ordine in cui si incontrano lavorando — non in ordine alfabetico, perché più spesso si è visto il processo e non si sa come si chiama ciò che si è visto. Ogni voce dice che cosa cambia per chi lavora, non che cos'è. Come si lavora, per esteso, sta nel manuale operativo.",
  "glossary.operator": "Al banco dell'operatore",
  "glossary.quality": "Al cancello di qualità",
  "glossary.delivery": "Alla consegna",
  "glossary.admin": "Per chi amministra",
  "hint.inGlossary": "Nel glossario",
  "hint.about": "Che cosa vuol dire: {term}",
  "concept.lease.term": "Lease",
  "concept.lease.says": "Questo candidato è tuo per novanta secondi — una prenotazione: nessun altro lo vede. Se ti allontani torna in coda per qualcun altro, ed è normale — non hai perso niente e non hai sbagliato.",
  "concept.rank.term": "Rango",
  "concept.rank.says": "Quanto è grave, da S1 a S4. Confermare cambiando il rango vuol dire: l'anomalia c'è, ma non con la gravità che il modello propone.",
  "concept.margin.term": "Margine",
  "concept.margin.says": "La distanza da sola non dice niente: la soglia dipende dalla tensione della linea e da che cosa c'è sotto il filo. Il margine mette lo zero sulla soglia — sotto zero è una violazione, sopra no.",
  "concept.outbox.term": "Casella d'uscita",
  "concept.outbox.says": "I verdetti già presi che non sono ancora arrivati al servizio. Continua a lavorare: partono da soli quando la rete torna. Se uno non riesce a mettersi al sicuro la schermata te lo dice e non avanza.",
  "concept.intent.term": "Verdetto in volo",
  "concept.intent.says": "Un verdetto che hai già dato e che il servizio non ha ancora applicato: è partito dalla casella d'uscita e conta solo quando atterra. Finché è in volo nessuno riprende quel candidato, e il congelamento aspetta che sia arrivato.",
  "concept.snapshot.term": "Snapshot",
  "concept.snapshot.says": "L'ultima lettura buona, tenuta sul tuo navigatore per quando la rete manca. Da uno snapshot si guarda e non si decide: ciò che vedi può essere vecchio di minuti, e la schermata ti dice di quando è.",
  "concept.freeze.term": "Congelamento",
  "concept.freeze.says": "Ferma ciò che si sta controllando, non il lavoro degli operatori. Senza, il campione cambierebbe sotto gli occhi di chi lo sta guardando.",
  "concept.sample.term": "Campione",
  "concept.sample.says": "Il 5 % del lavoro, mai meno di trenta casi, sorteggiato per gruppi e non a caso: su una popolazione fatta quasi tutta di casi facili, un sorteggio uniforme guarderebbe quasi solo casi facili.",
  "concept.seal.term": "Sigillo",
  "concept.seal.says": "La firma che dice: questa commessa è stata controllata, su questa fotografia, con questo campione. Se dopo un operatore cambia un verdetto il sigillo decade da solo — ciò che avevi controllato non è più ciò che partirebbe.",
  "concept.delivery.term": "Consegna",
  "concept.delivery.says": "Il documento che parte al committente. Si congela quando si compone, non quando parte: fra i due c'è il tempo della verifica, e in quel tempo un verdetto può essere ritirato.",
  "concept.catalogEdition.term": "Edizione del catalogo",
  "concept.catalogEdition.says": "Il vocabolario dei codici, nella versione in vigore. Ogni consegna porta scritta la propria: senza, una consegna di sei mesi fa non si spiegherebbe più.",
  "concept.hypothesis.term": "Ipotesi",
  "concept.hypothesis.says": "Una decisione presa da noi perché il committente non ha ancora risposto. Non è una regola: è una scelta dichiarata, e cambierà quando la risposta arriva.",
  "delivery.scalesTitle": "Due scale a confronto",
  "delivery.scalesWhy": "La tabella del § 6.5 e le nostre soglie da tensione non sono gli stessi numeri e nemmeno lo stesso modello. Qui stanno accanto e non decidono niente: nessuna riga della consegna cambia. La domanda 8.7 al committente è se le fasce sostituiscano la formula o la accompagnino.",
  "delivery.scalesFrontier": "A {kv} kV: il nostro contatto è {touch} m e la fascia «urgente» finisce a {urgent} m; noi smettiamo di attribuire a {limit} m e la loro tabella arriva a {table} m.",
  "delivery.scalesCounts": "{agree} d'accordo · {diverge} divergenti · {incomparable} non confrontabili",
  "delivery.scalesUnexplained": "{n} divergenze senza spiegazione: da capire prima di scriverne al committente.",
  "delivery.scalesNone": "Nessuna constatazione con una distanza misurata.",
  "delivery.colDistance": "Distanza",
  "delivery.colOurs": "Noi",
  "delivery.colTheirs": "ST § 6.5",
  "delivery.colVerdict": "Esito",
  "delivery.verdict.agree": "coincidono",
  "delivery.verdict.diverge": "divergono",
  "delivery.verdict.incomparable": "non confrontabili",
  "delivery.scalesShow": "Le due scale accanto",
  "delivery.issueIndex": " · anomalia {n}",
  "delivery.onHypothesis": "poggia sulla nostra ipotesi «{name}»",
  "delivery.modelTitle": "Modello {version}",
  "delivery.modelNone": "— nessuno",
  "delivery.modelMetrics": "R1 {r1} · R2 {r2} · errore {error}",
  "delivery.modelCounts": "{declared} dichiarazioni umane, {predicted} predizioni, {matched} corrispondenze",
  "delivery.modelMissing": "manca: {list}",
  "delivery.modelNote": "Le cifre del modello non trattengono la consegna: questa è verificata da una persona.",
  "delivery.annex5": "Soglie dell'Allegato 5",
  "delivery.fromCustomer": "richiesta dal committente",
  "delivery.ourHypothesis": "nostra ipotesi",
  "export.offline": "Offline: sola lettura, nessun esito si registra.",
  "export.snapshot": "Snapshot delle {when} — non è una lettura dal servizio.",
  "export.outcomeFailed": "Esito non registrato.",
  "export.customerOutcome": "Esito del committente",
  "export.accept": "Registra accettata",
  "export.rejectReason": "Motivo del respingimento",
  "export.externalRef": "Riferimento esterno",
  "export.reject": "Registra respinta",
  "export.docFailed": "Il documento non si scarica in questo momento.",
  "lifecycle.unread": "Le tappe non si leggono",
  "lifecycle.reading": "Lettura delle tappe…",
  "lifecycle.heading": "Lavorazione del pacchetto",
  "lifecycle.leftBehind": "Rimasto indietro",
  "lifecycle.noteOutsideUploader": "Arrivato fuori dal caricatore: niente da contare qui.",
  "lifecycle.leftNote": "Alla consegna questi punti bloccano l'invio: si vedono qui per non trovarli alla validazione, a turno già speso.",
  'flight.heading': 'Il volo',
  'flight.note': "Le promesse del committente, misurate con le stesse soglie della consegna. Non misurato non è zero.",
  'flight.sampled': 'esposizione e fuoco letti su {n} fotogrammi di {of}',
  'flight.colPromise': 'Promessa',
  'flight.colMeasured': 'Misurato',
  'flight.colBound': 'Limite',
  'flight.colState': 'Stato',
  'flight.colBasis': 'Origine',
  'flight.metadata': 'Fotogrammi con posa e ottica',
  'flight.altitude': 'Quota sopra i sostegni',
  'flight.gsd': 'Dettaglio a terra (mediana)',
  'flight.gsdPromised': 'Dettaglio a terra promesso',
  'flight.swath': 'Fascia coperta dagli scatti',
  'flight.density': 'Densità della nuvola',
  'flight.cir': 'Interruzioni dei conduttori (CIR)',
  'flight.wsr': 'Buchi nella fascia (WSR)',
  'flight.sir': 'Buchi sui sostegni (SIR)',
  'flight.exposure': 'Fotogrammi ben esposti',
  'flight.focus': 'Fotogrammi a fuoco',
  'flight.within': 'nella norma',
  'flight.outside': 'fuori norma',
  'flight.outsideBlocks': 'fuori norma · blocca la consegna',
  'flight.unmeasured': 'non misurato',
  'flight.basisNorm': 'norma',
  'flight.basisContract': 'promessa del committente',
  'flight.basisHypothesis': 'ipotesi nostra',
  "pool.session": "Sessione di verifica",
  "pool.sessionOpen": "Sessione aperta · {n} candidati riservati · {heartbeat}",
  "pool.degraded": "connessione degradata",
  "pool.heartbeat": "battito ogni {n}s",
  "pool.contended": "Nessun candidato libero su questa commessa: qualcun altro la sta già lavorando.",
  "pool.closeSession": "Chiudi la sessione",
  "cockpit.source": "Sorgente",
  "cockpit.element": "Elemento",
  "cockpit.lease": "Lease",
  "cockpit.expires": " · scade {when}",
  "cockpit.norm": "norma",
  "cockpit.notExportable": "Nessun fotogramma la inquadra: non è esportabile.",
  "cockpit.drawBox": "Ridisegna il riquadro trascinando.",
  "cockpit.modeRank": "Modo rango: la cifra da 1 a 4 dichiara il rango e conferma. Esc per uscirne.",
  "cockpit.modeReason": "Modo motivo: la cifra scegle il motivo del rifiuto. Esc per uscirne.",
  "cockpit.exitedRank": "Fuori dal modo rango: tornano le lettere dei verdetti e della navigazione.",
  "cockpit.exitedReason": "Fuori dal modo motivo: la cifra non indica più un motivo, torna a confermare.",
  "cockpit.exitedDraw": "Fuori dal disegno del riquadro: resta il riquadro di prima.",
  "cockpit.boxCorrected": "Riquadro corretto: parte con la conferma.",
  "cockpit.polygonCorrected": "Contorno disegnato: parte con la conferma, col riquadro che lo contiene.",
  "cockpit.drawPolygon": "Disegna il contorno: un clic per vertice, Invio o doppio clic per chiudere, Backspace toglie l'ultimo vertice.",
  "cockpit.observe": "Banco in sola osservazione: senza sessione di verifica si guarda il lavoro, non si decide. Apri una sessione qui, o riapri la coda dal pool.",
  "cockpit.startHere": "Apri una sessione qui",
  "cockpit.otherViews": "altri punti di vista",
  "cockpit.turnOver": "Il turno su questa commessa è finito: riapri la coda dal pool per riprendere a decidere.",
  "cockpit.lastCandidate": "Ultimo candidato del batch: non c'è un successivo da guardare.",
  "cockpit.firstCandidate": "Primo candidato del batch: non c'è un precedente da guardare.",
  "cockpit.noStrip": "Il nastro dei fotogrammi non è letto: questo candidato non ha un fotogramma, o il servizio non ha risposto.",
  "cockpit.firstFrame": "Primo fotogramma di questa camera: non c'è un precedente.",
  "cockpit.lastFrame": "Ultimo fotogramma di questa camera: non c'è un successivo.",
  "cockpit.lookingElsewhere": "Stai guardando un fotogramma senza candidato in coda: qui si guarda, non si decide. J o K tornano al candidato, G dichiara un'anomalia su questo fotogramma.",
  "cockpit.lookAlt": "Fotogramma {filename}, senza candidato in coda: le anomalie già registrate sono disegnate sopra",
  "cockpit.lookNoPyramid": "Il fotogramma {filename} non ha ancora la piramide: non si può aprire qui.",
  "cockpit.frameStrip": "Nastro dei fotogrammi",
  "cockpit.frameOf": "Fotogramma {n} di {total}",
  "cockpit.hudCamera": "camera {name}",
  "cockpit.frameCandidates": "{n} candidati",
  "cockpit.frameFindings": "{n} anomalie",
  "cockpit.frameReviewed": "revisionato",
  "cockpit.frameUnreviewed": "non revisionato",
  "cockpit.stripReading": "Lettura del nastro…",
  "cockpit.stripEmpty": "Nessun fotogramma sotto questo candidato.",
  "cockpit.tools": "Strumenti sulla tela",
  "cockpit.toolsNoFrame": "Nessun fotogramma su cui lavorare",
  "cockpit.toolBox": "Ridisegna il riquadro",
  "cockpit.toolPolygon": "Disegna il contorno",
  "cockpit.toolOne": "Scala 1:1",
  "cockpit.toolFit": "Inquadra il fotogramma",
  "cockpit.toolFinding": "Vai alla trovata",
  "cockpit.toolHide": "Nascondi i disegni",
  "cockpit.keySpace": "Spazio",
  "cockpit.drawingBox": "Trascina sul fotogramma · Esc annulla",
  "cockpit.drawingPolygon": "{n} vertici · un clic per vertice · Invio chiude · Backspace toglie · Esc annulla",
  "cockpit.noManualExit": "Le foto si aprono dalla commessa: questo banco non ha l'uscita.",
  "cockpit.nothingToDefer": "Questo candidato non è in mano a questa sessione: non c'è niente da rinviare.",
  "cockpit.offlineDefer": "Offline: il rinvio ha bisogno del servizio. Decidi ciò che tieni in mano, oppure aspetta che la rete torni.",
  "cockpit.deferFailed": "Il rinvio non è arrivato al servizio: il candidato resta in mano fino alla scadenza del lease.",
  "cockpit.s1Blocked": "S1 non ha un livello nella Specifica Tecnica: conferma a S2 se un lavoro c'è, oppure dichiara un falso positivo.",
  "cockpit.queueReadFailed": "Lettura della coda non riuscita: {message}",
  "cockpit.verdictUnrecorded": "Verdetto non registrato: {message}",
  "cockpit.routeConflict": "Conflitto route",
  "cockpit.routeConflictActive": "Conflitto route attivo:",
  "cockpit.openConflict": "Apri il contesto route del conflitto",
  "cockpit.hideNotice": "Nascondi l'avviso",
  "cockpit.queueUnread": "Coda non letta",
  "cockpit.queueUnreadBody": "La coda non è stata riletta: {detail}",
  "cockpit.queueUnreadHint": "Ciò che si tiene in mano resta decidibile: la rilettura serve a vedere il resto del batch.",
  "cockpit.rereadQueue": "Rileggi la coda",
  "cockpit.verdictUnrecordedTitle": "Verdetto non registrato",
  "cockpit.candidateBack": "Il candidato è tornato davanti: va deciso di nuovo.",
  "cockpit.retryFromStrip": "Riprendilo dal nastro quando vuoi: resta scritto nell'elenco dei guasti.",
  "cockpit.readingQueue": "Lettura della coda…",
  "cockpit.queueUnreadEmpty": "La coda non è stata letta: riprova dall'avviso qui sopra.",
  "cockpit.contendedEmpty": "Nessun candidato libero su questa commessa: la stanno lavorando altri. Torna al pool o riprova fra poco.",
  "cockpit.noneWaiting": "Nessun candidato in attesa su questa commessa: non c'è altro da decidere qui.",
  "cockpit.noneWaitingNext": "Il passo successivo sta nella Panoramica.",
  "cockpit.candidateGone": "Il candidato indicato non esiste più su questa commessa.",
  "cockpit.readingCandidate": "Lettura del candidato…",
  "cockpit.alreadyDecided": "Questo candidato ha già un verdetto: qui si legge, non si ridecide. Per cambiarlo si passa dalla coda.",
  "cockpit.notInBatch": "Questo candidato non è nel tuo batch: lo si guarda, non lo si decide. Riprendilo dalla coda per deciderlo.",
  "cockpit.decidedConfirmed": "Confermato {rank}",
  "cockpit.decidedRejected": "Respinto: {reason}",
  "cockpit.decidedBy": "da {who}, {when}",
  "cockpit.batchDone": "Batch esaurito: chiudi la sessione per restituire ciò che resta, oppure torna al pool per prenderne altro.",
  "cockpit.modeDraw": "DISEGNO RIQUADRO",
  "cockpit.modeDrawPolygon": "DISEGNO CONTORNO",
  "cockpit.modePickReason": "SCELTA DEL MOTIVO",
  "cockpit.modePickRank": "SCELTA DEL RANGO",
  "cockpit.viewer": "Candidato in verifica",
  "cockpit.noFrameDecide": "Nessuna foto di questo punto. Si decide su codice, rango e margine; la consegna non lo esporterà.",
  "cockpit.altFrame": "Fotogramma del candidato {name}",
  "cockpit.altFrameFile": "Fotogramma del candidato {name}, file {filename}",
  "cockpit.sessionState": "Stato della sessione",
  "cockpit.job": "Commessa",
  "cockpit.sessionOpen": "aperta · scade alle {when}",
  "cockpit.waitingCount": "{n} in attesa",
  "cockpit.decidedCount": "{n} decisi",
  "cockpit.toSend": "{n} da inviare",
  "cockpit.opening": "Apertura della sessione…",
  "cockpit.resumed": "Sessione ripresa: i candidati erano già in mano a questa scheda.",
  "cockpit.closeSession": "Chiudi la sessione",
  "cockpit.backToPool": "Torna al pool",
  "cockpit.queueStrip": "Coda di orientamento",
  "cockpit.queueEmpty": "Coda vuota.",
  'error.leaseLost':
    "Il lease è scaduto: il candidato è tornato in coda e va ripreso.",
  'error.leaseNotYours': "Il lease è di un altro: si attende, oppure lo si fa scadere.",
  'error.leaseMismatch': "Il gettone è di un altro candidato.",
  'error.sessionExpired': "La sessione di verifica è scaduta: riapri la coda dal pool.",
  'error.intentStale': "Il verdetto in volo non vale più: il candidato va ripreso e deciso di nuovo.",
  'error.staleEpoch': "La verifica di questa commessa è stata riaperta nel frattempo: il lavoro precedente non vale più, si riparte da ciò che c'è ora.",
  'error.leaseLimit': "Hai già il massimo di candidati in mano: decidine o rilasciane uno prima di prenderne altri.",
  'error.candidateLeased': "Il candidato è in mano a un'altra sessione: si attende, oppure un supervisore ne forza la scadenza con un motivo.",
  'error.candidatePending': "Su questo candidato c'è già un verdetto in volo: aspetta che atterri.",
  'error.coveragePending': "Su questo elemento c'è già una dichiarazione in volo: aspetta che atterri.",
  'error.sessionClosed': "La sessione di verifica è chiusa: riapri la coda dal pool.",
  'error.intentRejected': "Questo verdetto è stato respinto dal servizio: insistere non lo registra. Riprendi il candidato e decidi di nuovo.",
  'error.versionConflict': "Il candidato è cambiato da quando lo hai preso — qualcun altro ha deciso o il lavoro è stato riaperto: riprendilo e decidi sullo stato attuale.",
  'error.coverageConflict': "La copertura di questo elemento è cambiata nel frattempo: la dichiarazione va rifatta sullo stato attuale.",
  'error.notYours': "Si annulla solo il proprio verdetto; su quello di un altro si decide di nuovo.",
  'error.nothingToUndo': "Il candidato non ha un verdetto da annullare.",
  'error.undoElapsed': "Il tempo per annullare è passato: riprendi il candidato e decidi di nuovo.",
  'error.shadowPrediction': "Questa proposta viene da un modello non ancora collaudato: si guarda, non si decide.",
  'error.freezeBlocked': "Il congelamento non parte: qualcuno sta ancora lavorando, o restano conflitti e buchi da chiudere.",
  'error.coverageIncomplete': "La copertura ha ancora buchi: il sigillo non chiude una commessa scoperta.",
  'error.coverageInFlight': "Ci sono dichiarazioni di copertura ancora in volo: aspetta che atterrino.",
  'error.notFrozen': "La commessa non è congelata: prima si congela, poi si campiona e si sigilla.",
  'error.emptyPopulation': "Non ci sono verdetti in piedi da campionare.",
  'error.sampleIncomplete': "Il campione non è completo: ogni caso va confermato o ribaltato prima del sigillo.",
  'error.sampleNotCurrent': "Il campione appartiene a un congelamento precedente: va sorteggiato di nuovo.",
  'error.notInSample': "Questo candidato non è nel campione: il ricontrollo si fa sul campione, non sulla coda.",
  'error.sealBlocked': "Il sigillo non passa: restano conflitti o finding non validi.",
  'error.sealMissing': "La consegna non si compone senza un sigillo di qualità valido.",
  'error.sealStale': "Il sigillo non vale più: un verdetto è cambiato dopo, o il congelamento è caduto. Si ricontrolla e si sigilla di nuovo.",
  'error.noActiveCatalog': "Nessuna edizione del catalogo è attiva: la consegna porta il timbro dell'edizione, e senza non si compone.",
  'error.deliveryInvalidated': "Questa consegna è stata ritirata: il congelamento è caduto. Non si verifica e non si invia.",
  'error.alreadySubmitted': "Questa consegna è già partita: ciò che è partito non si rivede, si compone una consegna nuova.",
  'error.notSubmitted': "La ricevuta nasce con l'invio: questa consegna non è ancora partita.",
  'error.noteRequired': "Per inviare con gli avvisi aperti serve una motivazione scritta, che resta con la consegna.",
  'error.reasonRequired': "Il motivo è obbligatorio: senza, non si sa che cosa correggere.",
  'error.referenceRequired': "Il riferimento della comunicazione del committente è obbligatorio: senza, non si sa da dove viene il respingimento.",
  'error.metricsNotMet': "Le cifre non bastano ancora per mostrare il modello.",
  'error.lastManager': "È l'ultima utenza che può aprirne altre: toccarla chiuderebbe la porta dall'interno.",
} as const

export type MessageKey = keyof typeof it

export const en: { [K in MessageKey]: string } = {
  'lang.group': 'Language',
  'cloud.looks': 'What to look at',
  'cloud.noFrameButCloud': 'No photo of this point: look at the cloud. Delivery will not export it.',
  'cloud.lookPhoto': "Image",
  'cloud.lookCloud': 'Cloud',
  'cloud.lookProfile': 'Profile',
  'cloud.unavailableForSource': 'Cloud and profile are available only for LiDAR candidates.',
  'cloud.reading': 'Reading the cloud…',
  'cloud.notCut': 'The cloud swatch of this anomaly has not been cut yet: it is redone from the ingest (anomalies/recut).',
  'cloud.altCloud': 'The point cloud around the candidate, in three dimensions: drag to turn, wheel to zoom',
  'cloud.altProfile': 'The profile along the span: the wire, the worst point, the threshold circle',
  'cloud.legendConductor': 'conductors',
  'cloud.legendVegetation': 'vegetation',
  'cloud.legendGround': 'ground',
  'cloud.legendPole': 'poles',
  'cloud.legendBuilding': 'buildings',
  'cloud.points': 'points within {r} m',
  'cloud.norm': 'norm',
  'cloud.axisNote': 'No span recorded: the axis is the direction to the wire.',
  'viewer.reading': 'Reading the frame…',
  'viewer.readingFor': 'Reading the frame… {s} s — the archive is slow, not stuck',
  'viewer.unreadable': 'The frame does not open: {why}',
  'viewer.scale': 'Scale',
  'viewer.frame': 'Frame',
  'tab.login': 'Sign in',
  'tab.pool': 'Jobs',
  'tab.job': "Overview",
  'tab.map': 'Map',
  'tab.photos': "Photos",
  'tab.anomalies': 'Anomalies',
  'tab.queue': 'Desk',
  'tab.coverage': 'Coverage',
  'tab.element': 'Element',
  'tab.quality': 'Quality',
  'tab.delivery': 'Delivery',
  'tab.deliveries': 'Deliveries',
  'tab.uploads': 'Upload',
  'tab.admin': 'Administration',
  'tab.glossary': 'Glossary',
  'login.enter': 'Sign in',
  'login.checking': 'Checking…',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.offline': 'The service did not respond: try again shortly.',
  'login.brandLabel': 'What GridFly does',
  'login.claimBefore': 'Every anomaly,',
  'login.claimAccent': 'seen once',
  'login.claimAfter': 'and decided well.',
  'login.lead':
    'Review of aerial power-line inspections: from the flight package to the SWIM delivery, with every verdict undoable and every receipt readable again.',
  'login.footer': 'No data leaves this installation',
  'password.title': 'Password change required',
  'password.lead': 'Replace the temporary password before opening any other page.',
  'password.current': 'Current password',
  'password.next': 'New password',
  'password.confirm': 'Confirm new password',
  'password.mismatch': 'The two do not match.',
  'password.submit': 'Change password',
  'password.busy': 'Changing…',
  'password.failed': 'The change did not go through: try again.',
  'chrome.skip': 'Skip to content',
  'chrome.signOut': 'Sign out',
  'chrome.online': 'Online',
  'chrome.offline': 'Offline',
  'chrome.networkOn': 'Network online',
  'chrome.networkOff': 'Network offline',
  'chrome.outbox': 'Outbox {n}',
  'chrome.conflicts': 'Conflicts {n}',
  'chrome.identity': 'Session identity',
  'chrome.commessa': 'Job context',
  'chrome.acquisitionUnknown': 'acquisition n/a',
  'rail.modules': 'Modules',
  'deliveries.loading': 'Reading the deliveries…',
  'deliveries.readFailed': 'The deliveries cannot be read',
  'deliveries.emptyTitle': 'No delivery has been sent yet.',
  'deliveries.emptyAction': 'Deliveries appear here once a job is sent to the customer.',
  'deliveries.colSent': 'Sent on',
  'deliveries.colJob': 'Job',
  'deliveries.colDeclarations': 'Declarations',
  'deliveries.colState': 'State',
  'deliveries.colSignedBy': 'Signed by',
  'deliveries.colChecksum': 'Checksum',
  'deliveries.submitted': 'Sent',
  'deliveries.accepted': 'Accepted',
  'deliveries.rejected': 'Rejected',
  'deliveries.noAuthor': 'not recorded',
  'operations.loading': 'Reading the sentinel…',
  'operations.readFailed': 'The sentinel does not answer',
  'operations.checkedAt': 'Checked at {when} · {n} acquisitions running',
  'operations.recheck': 'Check again',
  'operations.quietTitle': 'The sentinel sees no faults.',
  'operations.quietAction': 'Acquisitions, queues, backups and clock are in order. The check time is above.',
  'operations.colWhat': 'What',
  'operations.colDetail': 'Since when, and how much',
  'operations.colFirstStep': 'First step',
  'title.operations': 'Operations',
  'rail.operations': 'Operations',
  'rail.work': 'Jobs',
  'rail.workWaiting': 'Jobs · {n} to review',
  'rail.deliveries': 'Deliveries',
  'rail.upload': 'Upload',
  'rail.admin': 'Admin',
  'rail.help': 'Help',
  'nav.sections': 'Job sections',
  'nav.overview': 'Overview',
  'nav.ingest': 'Ingest',
  'nav.coverage': 'Coverage',
  'nav.qa': 'Review',
  'nav.quality': 'Quality',
  'nav.delivery': 'Delivery',
  'title.password': 'Password change',
  'title.upload': 'Package upload',
  'title.uploadReceipt': "Upload receipt",
  'title.ingest': "Ingest",
  'upload.openSessions': 'Uploads left open',
  'upload.startedAt': 'started on {when}',
  'upload.openedBy': ' · opened by {who}',
  'upload.resumeHint': 'Pick the folder again: what already arrived is not sent twice.',
  'who.uploader': 'whoever uploads the packages',
  'who.qa': 'a QA operator',
  'who.supervisor': 'a supervisor',
  'who.manager': 'whoever administers the installation',
  'unreachable.title': 'The service is not answering',
  'unreachable.body': 'The page retries by itself every few seconds. Nothing is lost: your access and the outbox stay on this workstation.',
  'privacy.title': 'Anonymization',
  'privacy.unread': 'The anonymization state cannot be read.',
  'privacy.done': 'Done',
  'privacy.pending': 'To do',
  'privacy.scanned': '{n} frames looked at out of {total}',
  'privacy.noneFound': 'No faces and no plates in the frames looked at.',
  'privacy.found': '{zones} zones to cover across {frames} frames.',
  'privacy.scan': 'Look for faces and plates',
  'privacy.rescan': 'Look again',
  'privacy.starting': 'Scan queued…',
  'title.deliveries': 'Deliveries',
  'title.pool': 'Jobs',
  'title.poolShared': 'The pool is shared: opening a queue leases its candidates.',
  'title.commessa': "Overview",
  'title.queue': "Desk",
  'title.desk': "Desk",
  'title.search': 'Photos',
  'title.coverage': 'Coverage',
  'title.quality': 'Quality sample',
  'lifecycle.stage.reception': 'Package received',
  'lifecycle.stage.integrity': 'Integrity check',
  'lifecycle.stage.georeferencing': 'Georeferencing',
  'lifecycle.stage.cloud': 'Point cloud and clearances',
  'lifecycle.stage.detection': 'Anomaly detection',
  'lifecycle.stage.ready': 'Ready for review',
  'lifecycle.count.objects': 'Objects received',
  'lifecycle.count.bytes': 'Bytes received',
  'lifecycle.count.frames': 'Frames',
  'lifecycle.count.located': 'With coordinates',
  'lifecycle.count.dated': 'With timestamp',
  'lifecycle.count.bound': 'Bound to an element',
  'lifecycle.count.spans': 'Spans rebuilt',
  'lifecycle.count.measured': 'Violations measured',
  'lifecycle.count.gauged': 'With ground detail',
  'lifecycle.count.predicted': 'Model predictions',
  'lifecycle.count.waiting': 'In the review queue',
  'error.reviewFrozen': 'The ordinary review is closed: the job is frozen for the quality check.',
  'title.delivery': 'Delivery',
  'title.exportReceipt': "Delivery receipt",
  'title.users': 'Users',
  'title.model': 'Model',
  'title.settings': 'Settings',
  'title.catalog': 'Catalog',
  'title.audit': 'Audit log',
  'guard.opening': 'Opening…',
  'guard.denied': 'Access denied (403)',
  'guard.requires': 'This page belongs to {who}.',
  'guard.noSafe': 'No permitted destination is available from this session.',
  'guard.openSafe': 'Open a permitted destination',
  'notFound.title': 'Page not found',
  'notFound.body': 'The requested address is not part of the V1 workflow.',
  'notFound.pool': 'Open the work pool',
  'cockpit.decision': 'Decision',
  'cockpit.confirm': 'Confirm as proposal',
  'cockpit.falsePositive': 'False positive',
  'cockpit.defer': 'Return to queue',
  'cockpit.manual': 'Open manual finding',
  'cockpit.undo': 'Undo',
  'cockpit.undoSeconds': 'Undo · {n} s',
  'cockpit.firstVerdicts': 'A verdict can be undone within five seconds, with Ctrl+Z or the command above. After that, it is corrected from the Anomalies tab.',
  'cockpit.chooseRank': 'Choose rank',
  'cockpit.ranks': 'Ranks',
  'cockpit.confirmRank': 'Confirm by changing rank',
  'cockpit.chooseReason': 'Choose reason',
  'cockpit.rejectReasons': 'Rejection reasons',
  'cockpit.rejectWithReason': 'Reject with a reason',
  'cockpit.rejectWithReasonCmd': 'Reject with reason…',
  'cockpit.rankHint': 'S then the digit',
  'cockpit.measured': 'Measured',
  'cockpit.marginLabel': 'Margin',
  'cockpit.confidenceOf': 'Model confidence {n}',
  'reason.nonAnomalia': 'Not an anomaly',
  'reason.altroTipo': 'Anomaly of a different kind',
  'reason.duplicato': 'Duplicate',
  'reason.illeggibile': 'Frame unreadable',
  'reason.elementoErrato': 'Wrong network element',
  'cockpit.sourceModel': 'model',
  'cockpit.sourceManual': 'declared by hand',
  'cockpit.sourceImport': 'imported',
  'pool.jobs': 'Jobs',
  'pool.readFailed': 'Jobs could not be read',
  'pool.requestId': 'request {id}',
  'pool.routeState': 'Pool route state',
  'pool.filterStatus': "Which jobs",
  'pool.sort': 'Order',
  'pool.sortPriority': 'Longest waiting first',
  'pool.sortRecent': 'Most recent first',
  'pool.sortActivity': 'Last activity first',
  'pool.page': 'Page',
  'pool.filterFrozen': 'Frozen',
  'pool.frozenEmptyTitle': 'No job is frozen right now.',
  'pool.frozenEmptyAction': 'A job freezes when the supervisor closes the review for the quality check. Until then it stays among the others.',
  'pool.pageOf': 'Page {n} of {m}',
  'pool.prevPage': 'Previous page',
  'pool.nextPage': 'Next page',
  'crumb.path': 'Path',
  'nav.adminSections': 'Administration sections',
  'ingest.openJob': 'Open the job',
  'receipt.openDeliveries': 'Deliveries',
  'deliveries.openReceipt': 'Receipt',
  'deliveries.openJob': 'Job',
  'pool.loading': 'Reading jobs…',
  'pool.emptyTitle': 'No package has been acquired yet.',
  'pool.emptyAction': 'Open a QA account or upload a package.',
  'pool.colJob': 'Job',
  'pool.colStatus': 'Status',
  'pool.colWaiting': 'To review',
  'pool.colLeased': 'In progress',
  'pool.colDecided': 'Decided',
  'pool.colAcquired': 'Acquired',
  'pool.colPlant': 'Plant',
  'pool.colOperators': 'Operators',
  'pool.kpiReview': 'To review',
  'pool.kpiReviewLine': '{jobs} jobs · {n} anomalies',
  'pool.kpiWorst': 'worst {rank}',
  'pool.kpiProgress': 'In progress',
  'pool.kpiProgressLine': '{n} candidates in hand · {people} people',
  'pool.kpiStale': 'Stale',
  'pool.kpiStaleLine': '{n} jobs silent for 3 days',
  'pool.kpiDelivery': 'Delivery',
  'pool.kpiDeliveryLine': '{frozen} frozen · {sent} with a delivery',
  'pool.mapArea': 'The network',
  'pool.mapHint':
    'Each track is a job, in the colour of its status in the table. Click a track to pick it; the table row lights it up here.',
  'pool.mapTitle': 'The {n} jobs on the network',
  'pool.mapJob': 'Job {id}',
  'pool.mapReading': 'Reading the network…',
  'pool.mapEmpty': 'No job has a position on the network yet.',
  'pool.colActivity': 'Last activity',
  'pool.nobody': 'nobody',
  'pool.never': 'never',
  'pool.inQualityControl': 'In quality control',
  'pool.openQueue': "Open the desk",
  'pool.openJob': 'Open the job',
  'pool.filterInReview': "With work",
  'pool.filterReady': "All",
  'pool.filterEmptyTitle': "Right now no job has candidates to judge.",
  'pool.filterEmptyAction': "Not a fault: a day without new work. Jobs can still be opened to look at them.",
  'pool.showInReview': "Show all jobs",
  'pool.statusError': 'Error',
  'pool.statusProcessing': 'Processing',
  'pool.statusQueued': 'Queued',
  'pool.statusToReview': 'To review',
  'pool.statusDelivered': 'Delivered',
  'pool.statusReady': 'Ready',
  'role.uploader': 'Package uploader',
  'role.qa_operator': 'QA operator',
  'role.supervisor': 'Supervisor',
  'role.job_manager': 'Job manager',
  'users.heading': 'Users',
  'users.readFailed': 'Accounts could not be read.',
  'users.requestFailed': 'The service did not accept the request.',
  'users.passwordTitle': 'Password to hand over',
  'users.passwordAccount': 'Account {login} ({name}).',
  'users.passwordNote':
    'Shown once: it cannot be read back; the archive keeps only its hash. Hand it over in person. The recipient must change it at first sign-in. If it is lost, generate another.',
  'users.passwordClose': 'Handed over, close',
  'users.openTitle': 'Open an account',
  'users.displayName': 'Full name',
  'users.role': 'Role',
  'users.openSubmit': 'Open and hand over the password',
  'users.openHint':
    'The full name appears next to verdicts: a login does not tell anyone who judged.',
  'users.listTitle': 'Who works on the platform',
  'users.loading': 'Reading accounts…',
  'users.colLogin': 'Username',
  'users.colName': 'Name',
  'users.colRole': 'Role',
  'users.colStatus': 'Status',
  'users.colActions': 'Actions',
  'users.roleOf': 'Role of {login}',
  'users.active': 'Active',
  'users.inactive': 'Deactivated',
  'users.mustChange': 'must change password',
  'users.deactivate': 'Deactivate',
  'users.reactivate': 'Reactivate',
  'users.resetPassword': 'Hand over a new password',
  'users.listHint':
    'Nobody is deleted: a verdict has an author, and a deleted author makes that verdict unverifiable. Deactivated accounts stay in the list because they authored verdicts already given.',
  'common.dash': '—',
  'common.none': 'none',
  'common.noneMasc': 'none',
  'common.no': 'no',
  'common.close': 'Close',
  'common.prevPage': 'Previous page',
  'common.nextPage': 'Next page',
  'common.search': 'Search',
  'settings.intro':
    "All decisions, not hypotheses only: showing only hypotheses would make the customer's answers look immutable.",
  'settings.loading': 'Reading decisions…',
  'settings.readFailed': 'Settings could not be read.',
  'settings.historyFailed': 'History could not be read.',
  'settings.versionFailed': 'The version was not recorded.',
  'settings.invalidJson': 'Value is not JSON: use true, false, 2, or [1, 2].',
  'settings.colDecision': 'Decision',
  'settings.colValue': 'Value',
  'settings.colSource': 'Source',
  'settings.colVersion': 'Version',
  'settings.colHistory': 'History',
  'settings.critical': 'critical',
  'settings.criticalTitle': 'Affects what is delivered: changing it requires a reason',
  'settings.hypothesis': ' · hypothesis',
  'settings.openHistory': 'Open history',
  'settings.historyTitle': 'History',
  'settings.historyLoading': 'Reading history…',
  'settings.noVersions': 'No version recorded: the current value comes from the initial migration.',
  'settings.colReason': 'Reason',
  'settings.colDecidedBy': 'Decided by',
  'settings.colWhen': 'When',
  'settings.registerTitle': 'Record a version',
  'settings.valueJson': 'Value (JSON)',
  'settings.source': 'Source',
  'settings.questionRef': 'Open question',
  'settings.reasonRequired': 'Reason (required)',
  'settings.reasonOptional': 'Reason (optional)',
  'settings.criticalNote':
    'This decision affects what is delivered: without a reason the service rejects the change, and the rejection is logged.',
  'settings.submit': 'Record version',
  'settings.sourceCustomer': 'Customer response',
  'settings.sourceNorm': 'Standard or contract annex',
  'settings.sourceHypothesis': 'Hypothesis awaiting response',
  'model.loading': 'Reading metrics…',
  'model.readFailed': 'Model status could not be read.',
  'model.shown': 'are shown to the operator',
  'model.hidden': 'remain hidden',
  'model.predictionsLead': 'Predictions',
  'model.metricsCaption': 'Metrics across all {n} measured jobs, not a selection',
  'model.colMetric': 'Metric',
  'model.colMeasured': 'Measured',
  'model.colThreshold': 'Contract threshold',
  'model.r1': 'R1 — anomalies found',
  'model.r2': 'R2 — correct severity level',
  'model.errorRate': 'E — incorrect predictions',
  'model.declared': 'Declared anomalies',
  'model.predicted': 'Predictions produced',
  'model.matched': 'Matches',
  'model.shortfall': 'What is missing',
  'model.hide': 'Hide predictions',
  'model.show': 'Show predictions',
  'model.notAcceptable':
    'Metrics do not allow showing the model. Showing unmeasured candidates makes the operator spend time evaluating the model instead of the line.',
  'catalog.importTitle': 'Import an extraction',
  'catalog.importFile': 'Extraction file (JSON)',
  'catalog.importNote':
    'Importing does not activate, not even the first release: activation is a separate decision.',
  'catalog.importedNew': ', new release',
  'catalog.importedUpdated': ', updated release',
  'catalog.notActivated': 'Not activated.',
  'catalog.importedPrefix': 'Imported',
  'catalog.importStats':
    'Added {added}, updated {updated}, unchanged {unchanged}. Open items: {conflicts}.',
  'catalog.releases': 'Releases',
  'catalog.releasesLoading': 'Reading releases…',
  'catalog.releasesEmpty': 'No release imported.',
  'catalog.colDocument': 'Document',
  'catalog.colActive': 'Active',
  'catalog.colContent': 'Content',
  'catalog.colOpen': 'Open items',
  'catalog.colImported': 'Imported',
  'catalog.colActions': 'Actions',
  'catalog.active': 'active',
  'catalog.activeSince': ' since {date}',
  'catalog.contentSummary': '{n} criticalities, {codes} codes',
  'catalog.openCount': '{n} to clarify',
  'catalog.activate': 'Activate',
  'catalog.releasesNote':
    'Exactly one release is active: activating another deactivates the previous one in the same transaction. Inactive releases remain because past deliveries were produced with them.',
  'catalog.conflictsTitle': 'Open items to clarify with the customer',
  'catalog.conflictsLoading': 'Reading open items…',
  'catalog.colSubject': 'Subject',
  'catalog.colIssue': 'What does not match',
  'catalog.colDetail': 'Detail',
  'catalog.conflictsNote':
    'They do not block activation: they are questions about the document, and keeping a catalog inactive because of them would stop work.',
  'catalog.readFailed': 'Releases could not be read.',
  'catalog.conflictsFailed': 'Open items could not be read.',
  'catalog.notJson': 'The file is not a JSON document.',
  'catalog.fileUnreadable': 'The file cannot be read.',
  'catalog.conflictDisputed': 'Conflicting severity levels across document sources',
  'catalog.conflictMissing': 'Referenced card missing from document',
  'catalog.conflictUnknown': 'Allowed levels cannot be derived from document',
  'audit.filters': 'Log filters',
  'audit.since': 'From date',
  'audit.until': 'To date',
  'audit.action': 'Action',
  'audit.actor': 'Who acted',
  'audit.actorPlaceholder': 'user identifier',
  'audit.subjectType': 'Subject type',
  'audit.subject': 'Subject',
  'audit.pageSize': 'Events per page',
  'audit.readFailed': 'Audit log could not be read.',
  'audit.exportFailed': 'Export is not available.',
  'audit.loading': 'Reading audit log…',
  'audit.noMatch': 'No events match these filters.',
  'audit.empty': 'The audit log is empty: it fills itself with the first recorded action — a verdict, a delivery, a settings change.',
  'audit.pageSummary': '{total} events, page {page} of {pages}.',
  'audit.colWhen': 'When',
  'audit.colAction': 'Action',
  'audit.colWho': 'Who',
  'audit.colSubject': 'Subject',
  'audit.colDetail': 'Detail',
  'audit.service': 'service',
  'audit.pages': 'Log pages',
  'audit.prepareExport': 'Prepare filtered events sheet',
  'audit.downloadExport': 'Download sheet',
  'audit.limitsNote':
    'At most {maxSize} events per page and {maxExport} per export: these are service limits, and requests above the limit are rejected rather than silently truncated. The log is read-only: events cannot be edited or deleted.',
  'rank.s0': 'Compliant',
  'rank.s1': 'Minor',
  'rank.s2': 'Moderate',
  'rank.s3': 'Severe',
  'rank.s4': 'Critical',
  'rank.unranked': 'Rank not declared',
  'margin.unmeasured': 'Not measurable',
  'margin.violation': 'Violation',
  'margin.critical': 'Critical margin',
  'margin.reduced': 'Reduced margin',
  'margin.compliant': 'Compliant',
  'keys.handRight': 'Navigation · right hand',
  'keys.handLeft': 'Verdicts · left hand',
  'keys.handCanvas': 'Canvas',
  'keys.handGlobal': 'Global',
  'keys.nextFinding': 'Next finding',
  'keys.previousFinding': 'Previous finding',
  'keys.nextFrame': 'Next frame in the flight (same camera)',
  'keys.previousFrame': 'Previous frame in the flight',
  'keys.confirm': 'Confirm as proposal',
  'keys.rankMode': 'Confirm by changing rank, then digit S1…S4',
  'keys.falsePositive': 'False positive',
  'keys.defer': 'Return an undecided candidate to the queue',
  'keys.manual': 'Open free search for a manual finding',
  'keys.confirmRank': 'Confirm at rank S2…S4',
  'keys.rejectReason': 'Reject with a reason, then the reason digit',
  'keys.redrawBox': 'Redraw the box',
  'keys.drawPolygon': 'Draw the contour',
  'keys.zoomOne': 'Scale 1:1',
  'keys.zoomFit': 'Fit the frame',
  'keys.zoomFinding': 'Zoom to finding',
  'keys.hideOverlays': 'Hold: hide overlays',
  'keys.undo': 'Undo last verdict',
  'keys.help': 'Keyboard map',
  'keys.toggleQueue': 'Close or open the frame strip',
  'keys.exitMode': 'Exit mode',
  'keys.close': 'Close map',
  'keys.openElement': 'Open the element sheet',
  'cockpit.openElement': 'Element sheet',
  'cockpit.noElementExit': "The element sheet opens from the job's desk: this screen has no exit.",
  'cockpit.noElement': 'This candidate is not on a network element: there is no sheet to open.',
  'title.element': 'Element sheet',
  'coverage.colSheet': 'Sheet',
  'coverage.openSheet': 'Sheet of {id}',
  'element.reading': 'Reading the sheet…',
  'element.heading': '{type} {id}',
  'element.line': 'Line',
  'element.code': 'Code',
  'element.endNodes': 'End nodes',
  'element.position': 'Position',
  'element.notInspected': 'Not inspected',
  'element.frames': 'Frames',
  'element.noFrames': 'No frame shows this element.',
  'element.frameCounts': '{candidates} candidates · {findings} findings',
  'element.frameReviewed': 'looked at',
  'element.framePrimary': 'primary',
  'element.candidates': 'Candidates',
  'element.noCandidates': 'No candidate on this element.',
  'element.colCode': 'Code',
  'element.colLevel': 'Level',
  'element.colMargin': 'Margin',
  'element.colFrame': 'Frame',
  'element.colVerdict': 'Verdict',
  'element.colOpen': 'Open',
  'element.openCandidate': 'Open in the desk',
  'element.undecided': 'undecided',
  'element.confirmed': 'confirmed',
  'element.rejected': 'rejected',
  'element.withdrawn': 'withdrawn',
  'element.findings': 'Findings',
  'element.noFindings': 'No finding written on this element.',
  'element.history': 'Past flights',
  'element.noHistory': 'This element does not appear in other jobs.',
  'element.pastFlight': 'Job {id} · {when}',
  'element.pastCounts': '{frames} frames · {findings} findings',
  'element.backToCandidate': 'Back to the candidate',
  'element.backToQueue': "Back to the desk",
  'element.openCoverage': 'Open coverage',
  'box.missing': '{field} of the box is missing.',
  'box.notInteger': '{field} of the box must be an integer number of pixels.',
  'box.outside': 'The box cannot start outside the frame.',
  'box.noArea': 'A box with no area indicates nothing: width and height must be above zero.',
  'box.overflowWidth': 'The box overflows the frame in width (maximum {n} px).',
  'box.overflowHeight': 'The box overflows the frame in height (maximum {n} px).',
  'box.fieldWidth': 'width',
  'box.fieldHeight': 'height',
  'cockpit.statePending': 'Awaiting verdict',
  'cockpit.stateDecisionPending': 'Decision in delivery',
  'cockpit.stateApplied': 'Verdict recorded',
  'cockpit.stateWithdrawn': 'Verdict withdrawn: the candidate awaits again',
  'cockpit.stateRejected': 'Verdict not recorded: pick up and decide again',
  'cockpit.stateStale': 'The candidate returned to the queue: pick up and decide again',
  'cockpit.stateDeferred': 'Returned to queue',
  'cockpit.stateOffline': 'Offline · no new acquisition: decide what you hold',
  'cockpit.stateDegraded': 'Degraded connection: heartbeat is not reaching the service',
  'cockpit.stateReconciling': 'Reconciliation in progress: before applying more',
  'cockpit.stateContended': 'No free candidates: the job is held by others',
  'cockpit.stateExhausted': 'Batch exhausted: close the session or return to the pool',
  'cockpit.stateClosed': 'Session closed: candidates returned to the queue',
  'cockpit.leaseMine': 'held by you',
  'cockpit.leasePending': 'decision in delivery',
  'cockpit.leaseOthers': 'held by others',
  'cockpit.leaseAvailable': 'available',
  "common.unreachable": "The service did not respond.",
  "ingest.phaseDone": "Done",
  "ingest.phase.verify.name": "Package check",
  "ingest.phase.verify.says": "checks that the package is whole and complete: manifest, signatures, expected folders",
  "ingest.phase.inventory.name": "Inventory",
  "ingest.phase.inventory.says": "counts and records what is inside: cameras, shots, clouds, trajectory",
  "ingest.phase.passport.name": "Line passport",
  "ingest.phase.passport.says": "reads the network registry: which supports and spans exist on this line",
  "ingest.phase.telemetry.name": "Trajectory",
  "ingest.phase.telemetry.says": "reads where the drone was at every instant, to place each shot in space",
  "ingest.phase.media.name": "Frames",
  "ingest.phase.media.says": "reads every shot and its data: an unreadable one is set aside, it does not stop the rest",
  "ingest.phase.binding.name": "Binding",
  "ingest.phase.binding.says": "ties each frame to the network element it covers",
  "ingest.phase.coverage.name": "Coverage",
  "ingest.phase.coverage.says": "measures which elements were seen and which were not: gaps show up here",
  "ingest.phase.analysis.name": "Distances on the cloud",
  "ingest.phase.analysis.says": "measures the clearances between the wire and what lies below, element by element",
  "ingest.phase.inference.name": "Model",
  "ingest.phase.inference.says": "asks the model what it sees in the shots: the candidates to judge are born here",
  "ingest.phase.report.name": "Report",
  "ingest.phase.report.says": "writes the acquisition summary and opens the job for work",
  "upload.heading": "GridFly — upload",
  "upload.folder": "Flight folder",
  "upload.noManifest": "This folder has no dataset.json: either it is the wrong folder, or the package is incomplete.",
  "upload.badJson": "dataset.json cannot be read as JSON: the file is damaged or truncated.",
  "upload.missingFiles": "{n} files did not arrive. What is already there stays: restarting sends only what is missing.",
  "upload.interrupted": "The upload was interrupted. Restarting sends only what is missing.",
  "upload.filesIn": "{n} files, {size}",
  "upload.inRoot": " in {root}",
  "upload.outside": "{n} files are outside the package folder and will not be uploaded.",
  "upload.reading": "Reading…",
  "upload.sending": "Sending…",
  "upload.send": "Upload",
  "upload.progress": "Progress",
  "upload.progressStatus": "{done} of {total} files — {bytesDone} of {bytesTotal} ({percent})",
  "upload.failedRetry": "{n} did not pass on the first round: they will be retried.",
  "upload.doneTitle": "Package uploaded",
  "upload.doneObjects": "{n} objects. Acquisition",
  "upload.doneWorking": "is being processed: nothing else is needed.",
  'upload.openReceipt': "Open the receipt",
  'upload.openIngest': "Open the ingest",
  "upload.cannot": "Cannot upload",
  "upload.note": "Please note",
  "upload.unnamed": "Unnamed survey",
  "upload.surveyType": "Survey type",
  "upload.undeclared": "not declared",
  "upload.crs": "Coordinate system",
  "upload.clouds": "Point clouds",
  "upload.trajectory": "Trajectory",
  "upload.present": "present",
  "upload.absent": "absent",
  "upload.swim": "Incoming SWIM",
  "upload.total": "Total",
  "upload.filesSize": "{n} files, {size}",
  "upload.cameras": "Cameras",
  "upload.noCameras": "No camera declared in the manifest.",
  "upload.colCamera": "Camera",
  "upload.colFolder": "Folder",
  "upload.colFrames": "Shots",
  "upload.colPose": "Poses",
  "upload.presentPl": "present",
  "upload.absentPl": "absent",
  "upload.untreated": "Not processed: {names}. Data from the flight that is not used.",
  "upload.fixFolder": "Fix the folder and choose it again.",
  "receipt.unavailable": "Receipt unavailable",
  "receipt.unread": "The receipt could not be read.",
  "receipt.reading": "Reading receipt…",
  "receipt.offline": "Offline snapshot, read-only: {when}.",
  "receipt.upload": "Upload",
  "receipt.jobIngest": "Ingest job",
  "receipt.package": "Package",
  "receipt.sha256": "SHA-256",
  "receipt.objects": "Objects",
  "receipt.bytes": "Bytes",
  "receipt.author": "Author",
  "receipt.serverTime": "Server time",
  "receipt.prepare": "Prepare receipt for download",
  "receipt.download": "Download receipt",
  "receipt.undownloadable": "The receipt cannot be downloaded right now.",
  "ingest.unread": "The ingest monitor is not responding.",
  "ingest.unavailable": "Ingest monitor unavailable",
  "ingest.reading": "Reading ingest monitor…",
  "ingest.offline": "Offline snapshot, read-only: {when}. Retry disabled.",
  "ingest.job": "Job",
  "ingest.state": "state",
  "ingest.attempts": "attempts",
  "ingest.retry": "Retry",
  "overview.heading": "Job context",
  "overview.empty": "This job is not in the pool",
  "overview.emptyAction": "Either the address is old, or the job belongs to another installation. The list says what is really there.",
  "overview.reading": "Reading the job…",
  "overview.offlineNoSnapshot": "Network absent and no snapshot to read.",
  "overview.offlineNote": "Offline, read-only: last snapshot {when}. Nothing can be changed from here.",
  "overview.offlineBare": "Offline, read-only. Nothing can be changed from here.",
  "overview.job": "Job",
  "overview.activityUnknown": "Activity not declared",
  "overview.acquisition": "acquisition",
  "overview.deliveryWord": "delivery",
  "overview.nextAction": "Next action",
  "overview.blockers": "Blockers",
  "overview.noBlockers": "No operational blocker at this time.",
  "overview.lifecycle": "Lifecycle",
  "overview.lifecycleHint": "Read-only from here: retrying a phase is something {who} does.",
  "overview.lifecycleMissing": "Lifecycle not available in this session.",
  "overview.metrics": "Metrics",
  "overview.metricsMissing": "Metrics not available: missing is not zero.",
  "overview.waiting": "Waiting",
  "overview.decided": "decided",
  "overview.gaps": "gaps",
  "overview.sample": "sample",
  "overview.openProgress": "Open progress",
  "overview.anomalies": "Anomalies",
  "overview.openAnomalies": "Open the list",
  "overview.anomaliesLine": "{waiting} to decide · {decided} decided",
  "overview.activity": "Activity",
  "overview.noEvents": "No recent events on this job.",
  "overview.openAudit": "Open the log",
  "overview.auditNeeds": "The full log is read by {who}.",
  "overview.phaseFailed": "Phase {phase} failed",
  "overview.conflictOne": "1 conflict",
  "overview.conflicts": "{n} conflicts",
  "overview.gapOne": "1 coverage gap",
  "overview.gapsCount": "{n} coverage gaps",
  "overview.invalidOne": "1 invalid finding",
  "overview.invalids": "{n} invalid findings",
  "overview.sessionOne": "1 live session",
  "overview.sessions": "{n} live sessions",
  "overview.leaseOne": "1 candidate in hand",
  "overview.leases": "{n} candidates in hand",
  "overview.intentOne": "1 verdict in flight",
  "overview.intents": "{n} verdicts in flight",
  "overview.resumeIngest": "Resume ingest",
  "overview.openConflicts": "Open conflicts",
  "overview.openGaps": "Open coverage gaps",
  "overview.openInvalid": "Open invalid findings",
  "overview.freezeBase": "Freeze the base",
  "overview.openSample": "Open the sample",
  "overview.openQuality": "Open the quality gate",
  "overview.openDelivery": "Open delivery",
  "overview.acqState": "Acquisition {state}.",
  "overview.acqStatePhase": "Acquisition {state} · {phase}.",
  "overview.ingestMissingLink": "Ingest to resume, but the link to the job or receipt is missing. ingest.retry or upload.receipt.read is required.",
  "overview.reasonConflicts": "Conflicts remain to close before freezing.",
  "overview.reasonGaps": "Coverage gaps remain to declare or cover.",
  "overview.reasonInvalid": "Invalid findings remain: freeze is blocked.",
  "overview.reasonLive": "Someone is still working here — open sessions, candidates in hand or verdicts in flight: the freeze waits for them to finish.",
  "overview.reasonOpen": "The review base is still open.",
  "overview.reasonSample": "The sample is missing or incomplete.",
  "overview.reasonSeal": "A valid seal is missing.",
  "overview.reasonCompose": "The seal is valid: delivery can be composed.",
  "overview.reasonWaiting": "{n} candidates waiting.",
  "overview.reasonOthers": "It does not unblock from here: {who} is needed.",
  "overview.reasonHeld": "The work is held by others.",
  "overview.reasonBlocks": "Blockers remain to close before freezing.",
  "coverage.statusCovered": "covered",
  "coverage.statusDeclared": "not inspected",
  "coverage.statusGap": "uncovered",
  "coverage.legend": "Legend of the marks",
  "coverage.meaningCovered": "someone looked at a frame that covers the element, or wrote an anomaly",
  "coverage.meaningDeclared": "declared not inspectable, with the reason written: delivery can explain it",
  "coverage.meaningGap": "neither seen nor declared: delivery stops here",
  "coverage.deliveryPending": "in delivery",
  "coverage.deliveryApplied": "recorded",
  "coverage.deliveryWithdrawn": "withdrawn",
  "coverage.deliveryRejected": "rejected",
  "coverage.deliveryStale": "to redo",
  "coverage.meaningPending": "declared and stored, not yet recorded by the service",
  "coverage.meaningApplied": "the service wrote the declaration",
  "coverage.meaningWithdrawn": "the declaration was cancelled",
  "coverage.meaningRejected": "the service did not record the declaration: it must be taken up again",
  "coverage.meaningStale": "the state it rested on has changed: take it up on the current one",
  "coverage.reviewed": "reviewed",
  "coverage.toReview": "to review",
  "coverage.meaningReviewed": "someone declared having looked at this frame",
  "coverage.meaningToReview": "nobody declared having looked at it",
  "coverage.noSession": "No review session on this job: coverage can be viewed, not declared. Come back online and reopen the module.",
  "coverage.reviewedDeclared": "{filename}: declared reviewed, in delivery.",
  "coverage.reviewedWithdrawn": "{filename}: review withdrawn, in delivery.",
  "coverage.gapDeclared": "Element {id}: declared not inspected, in delivery.",
  "coverage.gapWithdrawn": "Element {id}: declaration withdrawn, in delivery.",
  "coverage.codeRequired": "The anomaly code is required.",
  "coverage.findingQueued": "Anomaly {code} level {level} on element {id}: in delivery.",
  "coverage.heading": "Job coverage",
  "coverage.filterAll": "All",
  "coverage.search": "Search by element number",
  "coverage.openMap": "Open the map",
  "coverage.openPhotos": "Open the frames that cover it",
  "coverage.deliveryState": "Delivery status",
  "coverage.reading": "Reading coverage…",
  "coverage.noneBlocking": "No uncovered element out of {total}: coverage does not block delivery.",
  "coverage.blockingOne": "{n} uncovered element out of {total}: delivery stays blocked until they are seen or declared.",
  "coverage.blockingMany": "{n} uncovered elements out of {total}: delivery stays blocked until they are seen or declared.",
  "coverage.statsCoveredOne": "{n} covered",
  "coverage.statsCoveredMany": "{n} covered",
  "coverage.statsDeclaredOne": "{n} declared not inspected",
  "coverage.statsDeclaredMany": "{n} declared not inspected",
  "coverage.statsPending": "{n} in delivery",
  "coverage.statsRejectedOne": "{n} rejected",
  "coverage.statsRejectedMany": "{n} rejected",
  "coverage.offline": "Offline: declarations stay queued",
  "coverage.nothingToSend": "nothing to deliver",
  "coverage.toSend": "{n} to deliver",
  "coverage.noSessionShort": "no review session",
  "coverage.sessionOpen": "review session open",
  "coverage.ribbon": "Coverage ribbon",
  "coverage.elementStatus": "Element {id}: {status}",
  "coverage.noElements": "No element in the registry.",
  "coverage.filters": "Frame filters",
  "coverage.filtersTitle": "Filters",
  "coverage.filterReview": "Review",
  "coverage.allFrames": "All frames",
  "coverage.onlyReviewed": "Reviewed only",
  "coverage.onlyUnreviewed": "To review only",
  "coverage.filterCandidates": "Model candidates",
  "coverage.onlyWithout": "Without candidates only",
  "coverage.onlyWith": "With candidates only",
  "coverage.filterCamera": "Camera",
  "coverage.filterQuality": "Quality: maximum ground detail, in mm per pixel",
  "coverage.rowsPerPage": "Rows per page",
  "coverage.clearFilters": "Clear filters",
  "coverage.map": "Coverage map",
  "coverage.mapTitle": "Map",
  "coverage.noCoords": "No element with coordinates: coverage is read in the list beside.",
  "coverage.mapWith": "Map with {n} network elements",
  "coverage.feature": "Element {id}, {type}: {status}",
  'lineMap.title': 'Line map',
  'lineMap.reading': 'Reading the line\u2026',
  'lineMap.unreachable': 'The service does not answer: the line map cannot be drawn.',
  'lineMap.empty': 'No geometry: the map is drawn once the registry has coordinates.',
  'lineMap.summary': '{poles} elements \u00b7 {marks} anomalies with a position \u00b7 flight with {points} points',
  'lineMap.with': 'Line map with {poles} elements and {marks} anomalies',
  'lineMap.pole': 'Element {id}, {type}: {status}',
  'lineMap.worst': 'worst {rank}',
  'lineMap.mark': 'Candidate {code}, {rank}',
  'lineMap.violation': 'distance violation',
  'lineMap.legendViolation': 'Distance violation measured by LiDAR',
  'lineMap.legendCluster': 'Nearby anomalies grouped: the number says how many, the rim the worst; click to zoom in',
  'lineMap.cluster': '{n} anomalies grouped, worst {rank}',
  'map.scale': 'Scale: {length}',
  'lineMap.legendPole': 'Covered pole or span; the rim takes the tone of the worst level',
  'lineMap.legendGap': 'Pole or span without coverage',
  'lineMap.legendSpan': 'Line axis',
  'lineMap.legendFlight': 'Flight trajectory',
  "coverage.list": "Element list",
  "coverage.networkElements": "Network elements",
  "coverage.colElement": "Element",
  "coverage.colType": "Type",
  "coverage.colStatus": "Status",
  "coverage.colFrames": "Frames",
  "coverage.colDeclaration": "Declaration",
  "coverage.colAction": "Action",
  "coverage.framesReviewed": "{frames} · {reviewed} reviewed · {findings} anomalies",
  "coverage.chooseElement": "Choose element {id}",
  "coverage.noElementsShow": "No element to show.",
  "coverage.frames": "Frames",
  "coverage.readingFrames": "Reading frames…",
  "coverage.noFramesFiltered": "No frame matches these filters: clear one to widen the search.",
  "coverage.noFrames": "No frame in this job.",
  "coverage.framesPage": "{total} frames · page from {from} to {to}",
  "coverage.colFrame": "Frame",
  "coverage.colReview": "Review",
  "coverage.colCandidates": "Candidates",
  "coverage.colCamera": "Camera",
  "coverage.colQuality": "Quality",
  "coverage.colActions": "Actions",
  "coverage.unknownCamera": "unknown",
  "coverage.unmeasured": "not measured",
  "coverage.chooseFrame": "Choose {filename}",
  "coverage.withdrawReview": "Withdraw the review",
  "coverage.declareReviewed": "Declare reviewed",
  "coverage.subject": "Chosen subject",
  "coverage.gapTitle": "Element not inspected",
  "coverage.overview": "Coverage",
  "coverage.framesLine": "{frames} shot · {reviewed} reviewed · {findings} anomalies",
  "coverage.pickHint": "Pick an element in the list or on the line to declare or withdraw.",
  "coverage.gapPick": "Choose an element in the list to declare it not inspected or withdraw the declaration.",
  "coverage.elementLine": "Element {id} ({type})",
  "coverage.writtenReason": "Written reason: {reason}",
  "coverage.withdrawGap": "Withdraw the declaration of element {id}",
  "coverage.reason": "Reason",
  "coverage.noteOptional": "Note (optional)",
  "coverage.declareGap": "Declare element {id} not inspected",
  "coverage.manualTitle": "Anomaly found by hand",
  "coverage.manualPick": "Choose an element and a frame that covers it: an anomaly is always declared on a network element, never on a frame alone.",
  "coverage.frameNotOnElement": "Frame {filename} does not cover element {id}: filter frames for that element and choose one.",
  "coverage.altFrame": "Frame {filename}",
  "coverage.altThumb": "Thumbnail of frame {filename}",
  "coverage.noImage": "No image available: the box is composed with the four fields.",
  "coverage.boxLegend": "Box, in frame pixels",
  "coverage.boxX": "X (from the left)",
  "coverage.boxY": "Y (from the top)",
  "coverage.boxWidth": "Width",
  "coverage.boxHeight": "Height",
  "coverage.frameSize": "The frame measures {width}×{height} px.",
  "coverage.frameSizeUnknown": "Frame size is not known: the service rechecks the limits.",
  "coverage.code": "Code",
  "coverage.noCodes": "No code allowed for this element",
  "coverage.level": "Level",
  "coverage.record": "Record the anomaly",
  "coverage.recordNote": "Recorded as found by the operator, already confirmed, with its history.",
  "coverage.picked": "{filename} · element {id} ({type})",
  "search.unread": "Frames could not be browsed",
  "search.framesStatus": "{n} frames · {queue}",
  "search.openCoverage": "Open job coverage",
  "search.noFrames": "No frame to show.",
  "search.noPyramid": "{filename}: the pyramid is not available. The box is composed with the four fields.",
  "search.foundTitle": "Anomaly found",
  "search.element": "Network element",
  "search.noFramed": "No element covered by this frame",
  "search.drawHint": "Press B (or ▭ on the canvas) and draw the box by dragging on the frame, or type the four numbers.",
  "search.elementRequired": "The network element is required: an anomaly is declared on a span.",
  "search.notFramed": "The frame does not cover this element: choose one visible in the shot.",
  "search.noSession": "No review session on this job: you can look, not declare.",
  "search.findingQueued": "Anomaly {code} level {level} on {filename}: in delivery.",
  "photos.search": "Search by filename",
  "photos.cameraAll": "All",
  "photos.onlyUnreviewed": "Not reviewed only",
  "photos.onlyUntouched": "Without candidates only",
  "photos.count": "{shown} of {total} frames",
  "photos.loadMore": "Show {n} more",
  "photos.list": "Frames",
  "photos.chooseFrame": "Choose a frame on the left.",
  "photos.frame": "Frame",
  "photos.camera": "Camera",
  "photos.taken": "Taken",
  "photos.size": "Size",
  "photos.quality": "Ground detail",
  "photos.elements": "Elements covered",
  'photos.takenFromFilename': 'from the file name',
  'photos.takenFromAlignment': 'from the pose file',
  'photos.takenUnknown': 'no time: not in EXIF, pose or name',
  'photos.qualityFromAnomaly': 'from the anomaly in frame',
  'photos.qualityFromSpan': 'from the surveyed span',
  'photos.qualityFromElement': 'from the registry, in plan',
  'photos.qualityNoPose': 'no pose: not measurable',
  'photos.qualityNoSubject': 'no subject at a known distance',
  "photos.findings": "Anomalies on this frame",
  "photos.noFindings": "No anomaly on this frame.",
  "photos.waiting": "to decide",
  "photos.confirmed": "confirmed {rank}",
  "photos.rejected": "rejected",
  "photos.openDesk": "Open in the desk",
  "photos.onMap": "on the map",
  "photos.extent": "On the ground: {size}",
  "photos.extentUnknown": "On the ground: not measurable, the frame has no ground detail.",
  "photos.framesOfElement": "all its frames",
  "photos.declare": "Declare an anomaly",
  "photos.canvasHint": "Drag to pan · wheel to zoom · B for the box",
  "photos.reviewed": "reviewed",
  "photos.detail": "Frame sheet",
  "progress.short": "Progress",
  "progress.reading": "Reading progress…",
  "progress.offlineNote": "Offline, read-only: last snapshot {when}. Decisions are not made from here.",
  "progress.offlineBare": "Offline, read-only. Decisions are not made from here.",
  "progress.manual": "manual",
  "progress.gaps": "coverage gaps",
  "progress.sessions": "live sessions",
  "progress.leases": "candidates in hand",
  "progress.intents": "verdicts in flight",
  "progress.conflicts": "conflicts",
  "progress.invalid": "invalid findings",
  "progress.byLevel": "by level",
  "progress.frozen": "Base frozen",
  "progress.open": "Base open",
  "progress.sealValid": " · valid seal",
  "progress.freezeBlocks": " · {n} freeze blockers",
  "progress.resume": "Resume",
  "progress.openQuality": "Open quality",
  "quality.actionFailed": "Action did not succeed.",
  "quality.freezeRemain": "{message} Remaining: {parts}.",
  "quality.blockerSessions": "live sessions",
  "quality.blockerLeases": "candidates still in hand",
  "quality.blockerIntents": "verdicts still in flight",
  "quality.blockerConflicts": "conflicts",
  "quality.blockerInvalid": "invalid findings",
  "quality.loadFailed": "Read did not succeed.",
  "quality.offline": "Offline, read-only. Freeze, sample, review, seal and unfreeze are closed.",
  "quality.reading": "Reading the quality gate…",
  "quality.freeze": "Freeze",
  "quality.wasEpoch": " · was {epoch} · version {version}",
  "quality.sampleAfter": ": the sample is created only after freeze.",
  "quality.freezing": "Freezing…",
  "quality.freezeBase": "Freeze base",
  "quality.sample": "Sample",
  "quality.sampleMeta": "{n} cases · algorithm {algo} · seed {seed}",
  "quality.noSample": "No sample. It is generated from the frozen base only.",
  "quality.sampling": "Sampling…",
  "quality.generateSample": "Generate sample",
  "quality.secondary": "Secondary review",
  "quality.needSample": "Sample first, then the re-check.",
  "quality.sampleIntro": "The cases drawn from the frozen base, to re-check one by one: open in the desk, confirm or overturn. Freeze, sample and seal are governed from the delivery.",
  "quality.openDelivery": "Open the delivery",
  "quality.allReviewed": "All cases are re-checked.",
  "quality.caseElement": "element {n}",
  "quality.confirm": "Confirm",
  "quality.overturn": "Overturn",
  "quality.reviewing": "Secondary review in progress…",
  "quality.seal": "Seal",
  "quality.sealValid": "Valid seal · was {epoch} · freeze {freeze} · supervisor {supervisor}",
  "quality.noSeal": "No valid seal.",
  "quality.sealing": "Sealing…",
  "quality.applySeal": "Apply quality seal",
  "quality.unfreeze": "Unfreeze",
  "quality.unfreezeAction": "Reopen the review",
  "quality.unfreezeHint": "Reopens ordinary review and invalidates the seal and delivery drafts.",
  "quality.unfreezing": "Unfreezing…",
  "delivery.offline": "Offline: no delivery mutation.",
  "delivery.reading": "Reading the delivery state…",
  "delivery.done": "done",
  "delivery.now": "now",
  "delivery.later": "later",
  "delivery.step.review": "Review complete",
  "delivery.step.freeze": "Review base frozen",
  "delivery.step.sample": "Quality sample re-checked",
  "delivery.step.seal": "Quality seal",
  "delivery.step.privacy": "Frames anonymized",
  "delivery.parallel": "alongside the other stages",
  "delivery.privacyLine": "{n} of {total} frames scanned",
  "delivery.privacyPending": "The scan has started: the counts rise while the worker grinds.",
  "delivery.scan": "Start the scan",
  "delivery.rescan": "Scan again",
  "delivery.step.package": "Package composed",
  "delivery.step.validate": "Package validated",
  "delivery.step.send": "Send registered",
  "delivery.step.receipt": "Permanent receipt",
  "delivery.reviewLine": "{waiting} to decide · {decided} decided",
  "delivery.conflicts": "{n} conflicts",
  "delivery.gaps": "{n} coverage gaps",
  "delivery.openAnomalies": "Open the anomalies to decide",
  "delivery.openCoverage": "Open coverage",
  "delivery.openReport": "Open the printable report",
  "delivery.reportNote": "Print it from the browser (Print → PDF); thumbnails are valid for fifteen minutes.",
  "delivery.frozenLine": "frozen: epoch {epoch} · version {freeze} / {supervisor}",
  "delivery.notFrozen": "The review is open: freeze it when nothing is left to decide.",
  "delivery.freeze": "Freeze the review base",
  "delivery.unfreeze": "Reopen the review (invalidates the seal)",
  "delivery.noSample": "No sample: it is drawn from the frozen base.",
  "delivery.sampleLine": "{reviewed} of {required} cases re-checked",
  "delivery.createSample": "Draw the sample",
  "delivery.reviewSample": "Re-check the sample",
  "delivery.noSealYet": "No seal: it is set once the sample is re-checked.",
  "delivery.applySeal": "Set the seal",
  "delivery.noPackage": "No package composed.",
  "delivery.packageWithdrawn": "The composed package no longer stands: the base changed after it. Recompose it.",
  "delivery.recompose": "Recompose the package",
  "delivery.showPackage": "What the package contains",
  "delivery.validated": "Validated: the content is what leaves.",
  "delivery.notValidated": "Validate once the package is composed without errors.",
  "delivery.sentLine": "Sent by {who}.",
  "delivery.notSent": "Register the send once the package is validated.",
  "delivery.noReceipt": "The receipt is born with the send.",
  "delivery.compose": "Compose the package",
  "delivery.whatLeft": "What was sent",
  "delivery.validate": "Validate",
  "delivery.closedBy": "Sending stays closed while {n} blocking items remain.",
  "delivery.warningsOpen": "{n} warnings remain open: sending proceeds, but the reason travels with the delivery.",
  "delivery.noIssues": "No open remarks.",
  "delivery.whyWarnings": "Why sending with open warnings",
  "delivery.registerSend": "Record send",
  "delivery.undeliverable": "{n} confirmed anomalies are not deliverable: the network element or the frame is missing.",
  "delivery.errorsTitle": "Errors: they prevent sending",
  "delivery.warningsTitle": "Warnings: they do not prevent sending",
  "delivery.declarations": "declarations",
  "delivery.operator": "operator",
  "delivery.catalog": "catalog",
  "delivery.sha256": "sha-256",
  "delivery.prepareDoc": "Prepare the document as sent",
  "delivery.downloadDoc": "Download the document as sent",
  "delivery.openReceipt": "Open the permanent receipt",
  "delivery.sentWithWarnings": "Sent with open warnings: ",
  "delivery.rejected": "Rejected: {reason}",
  "delivery.stateIssues": "state {state} · {n} anomalies · catalog {catalog}",
  "delivery.checksum": "fingerprint {checksum}…",
  "delivery.redo": " · redoes a rejected delivery",
  "delivery.sealLine": "seal epoch {epoch} · version {freeze} / {supervisor}",
  "delivery.contents": "Contents: {n} declarations",
  "delivery.emptyContents": "No declaration: the delivery states work without criticalities.",
  "delivery.colElement": "Element",
  "delivery.colType": "Type",
  "delivery.colCode": "Code",
  "delivery.colLevel": "Level",
  "delivery.colImages": "Images",
  "purpose.what": "What is done here",
  "purpose.upload": "You bring a survey package into the platform: pick the folder, and before a byte is received it tells you whether something is missing.",
  "purpose.receipt": "The upload receipt: what came in, what was set aside, and from here you follow the acquisition.",
  "purpose.ingest": "The package acquisition, phase by phase: a stopped phase is resumed from here, and when the last one is done the job is ready for work.",
  "purpose.work": "The jobs: here you choose which one to work on, and see where each one stands.",
  "purpose.overview": "The job at a glance: where it is in its cycle, what stops it, and the next step — this is the place you come back to.",
  "purpose.map": "The line on the map: the elements with their state, to see where the problems are and where the flight went.",
  "purpose.anomalies": "The anomalies decided on this job, filterable by status and rank: what the delivery will declare.",
  "purpose.queue": "The cockpit: the queue brings candidates one at a time, and here you give the verdict — with the keys, without searching.",
  "purpose.search": "Free search in the frames: to find what the model did not see and write it down as an anomaly.",
  "purpose.coverage": "What was seen and what was not: gaps are declared here with their reason, otherwise the delivery stops.",
  "purpose.element": "The sheet of a network element: the frames that cover it and the anomalies that concern it.",
  "purpose.progress": "The job's progress: how many candidates wait, how many are decided, and what still keeps it open.",
  "purpose.quality": "The quality gate: freeze the work, re-check a sample, and apply the seal that allows the delivery.",
  "purpose.delivery": "The delivery to the client: compose the document, check it, send it and record the outcome.",
  "purpose.deliveries": "All the deliveries sent, with their outcome: which are accepted, which rejected, which are waiting.",
  "purpose.deliveryReceipt": "The receipt of a delivery: what was sent, when, and what the client answered.",
  "purpose.operations": "The installation's operations: backups, space, the sentinel — what the sentinel sees, you see too.",
  "purpose.users": "The users and their trades: who gets in, with which role, and who no longer does.",
  "purpose.model": "The model that proposes candidates: which edition is in use, how it is measured, and when to change it.",
  "purpose.settings": "The rules of decision and delivery: every change is a recorded decision, with who and why.",
  "purpose.catalog": "The anomaly catalog: the editions, which one is in use, and how a new one is loaded.",
  "purpose.audit": "The log: every recorded action, by whom and when — the trail to understand what happened.",
  "start.here": "Where to start",
  "aiuto.manual": "Manual",
  "aiuto.sections": "Help sections",
  "aiuto.manualIntro": "How the work is done, by trade: your chapter is open, the others sit below, closed — they tell you who receives your work.",
  "aiuto.manualLanguage": "The manual is in Italian, the language of the people working on the lines.",
  "aiuto.chapters": "Chapters",
  "aiuto.otherChapters": "The other trades",
  "aiuto.keysIntro": "The cockpit keys, hand by hand. In the cockpit the same map opens with the «?» key or from the command in the head.",
  "start.help": "The manual for your trade, the product's words and the keys are under",
  "start.rail": "The bar on the left holds the modules for your role: someone with another job sees different ones.",
  "start.uploader": "You bring survey packages into the platform. Pick the folder, not the individual files: it is read before a single byte is received, and if something is missing you are told now rather than in two hours. After the upload, ingestion runs on its own in nine phases; if one stops, the screen says which and why, and restarting duplicates nothing.",
  "start.qa": "You judge candidates: the queue brings them to you one at a time, you do not go looking. The day starts by taking a job from the list; if the list is empty, there is nothing to judge right now. The delivery to the customer is not yours — it is signed by whoever answers for its contents.",
  "start.supervisor": "You judge like the operators, and you also close the work: you freeze it, re-check the drawn sample, apply the seal and sign the delivery. Start from a job in the list; if it has no candidates, your work is the quality gate.",
  "start.manager": "You keep standing what lets everyone else work: accounts and roles, the code catalog, decisions taken while the customer has not answered, the model, the journal. You do not judge candidates and you do not deliver: administering is not having been trained to judge an anomaly.",
  "start.hypotheses": "{n} decisions are still our own hypotheses: they are waiting for the customer to answer.",
  "start.hypothesesNone": "No open decisions: every one has a norm or an answer behind it.",
  "start.toSettings": "Look at the decisions",
  "workspace.map": "Map",
  "workspace.photos": "Photos",
  "workspace.anomalies": "Anomalies",
  "workspace.delivery": "Delivery",
  "workspace.more": "More",
  "workspace.toReview": "{n} to review",
  "workspace.decided": "{n} decided",
  "map.title": "Job map",
  "map.elements": "Elements",
  "map.search": "Search an element",
  "map.kind": "Element type",
  "map.kindAll": "All",
  "map.layers": "Layers",
  "map.layerPoles": "Supports",
  "map.layerSpans": "Spans",
  "map.layerFlight": "Flight",
  "map.layerPhotos": "Photos",
  "map.layerMarks": "Anomalies",
  "map.summary": "{poles} elements · {photos} photos · {marks} anomalies with a position",
  "map.noneMatch": "No element matches: widen the filter, or clear it.",
  "map.zoom": "Zoom",
  "map.zoomIn": "Zoom in",
  "map.zoomOut": "Zoom out",
  "map.fit": "Whole line",
  "map.detail": "Detail",
  "map.hint": "Pick a support, a photo or an anomaly on the map or in the list.",
  "map.close": "Close",
  "map.coverage": "Coverage",
  "map.frames": "Frames",
  "map.framesOf": "{n} frame it · {reviewed} reviewed · {candidates} with candidates",
  "map.findings": "Anomalies",
  "map.coordinates": "Coordinates",
  "map.openElement": "Open the element sheet",
  "map.openQueue": "Open its candidates in the desk",
  "map.openCoverage": "Open coverage",
  "map.rank": "Rank",
  "map.source": "Source",
  "map.verdict": "Verdict",
  "map.confirmed": "confirmed",
  "map.waiting": "waiting",
  "map.margin": "Margin",
  "map.openCandidate": "Open in the desk",
  "map.photo": "Photo",
  "map.file": "File",
  "map.camera": "Camera",
  "map.openPhotos": "Browse the frames",
  "map.openFrame": "Open this frame",
  "map.framesOfElement": "All its frames",
  "map.thumbs": "Frames covering it",
  "map.marksOf": "Anomalies on this element",
  "map.legendPhoto": "Shot",
  "map.ground": "Background",
  "map.groundNone": "None",
  "map.groundMap": "Map",
  "map.groundSatellite": "Satellite",
  "title.map": "Map",
  "title.anomalies": "Anomalies",
  "anomalies.list": "Anomaly list",
  "anomalies.detail": "Anomaly sheet",
  "anomalies.unread": "The anomalies could not be read",
  "anomalies.status": "Status",
  "anomalies.all": "All",
  "anomalies.waiting": "To decide",
  "anomalies.confirmed": "Confirmed",
  "anomalies.rejected": "Rejected",
  "anomalies.rank": "Rank",
  "anomalies.anyRank": "Any rank",
  "anomalies.search": "Search by code, pole or frame",
  "anomalies.count": "{shown} of {total} anomalies",
  "anomalies.loadMore": "Show {n} more",
  "anomalies.none": "No anomaly here",
  "anomalies.noneFiltered": "Nothing is left with these filters: widen them, or clear them.",
  "anomalies.noneAtAll": "Anomalies are born from verdicts: until someone decides a candidate, this table stays empty.",
  "anomalies.clearFilters": "Clear filters",
  "anomalies.colRank": "Rank",
  "anomalies.colWhat": "Anomaly",
  "anomalies.colElement": "Element",
  "anomalies.colFrame": "Frame",
  "anomalies.colState": "Status",
  "anomalies.noFrame": "no frame",
  "anomalies.stateWaiting": "to decide",
  "anomalies.stateConfirmed": "confirmed {rank}",
  "anomalies.stateRejected": "rejected",
  "anomalies.decidedBy": "by {who}, {when}",
  "anomalies.history": "History",
  "anomalies.overview": "The job",
  "anomalies.colMargin": "Margin",
  "anomalies.colWho": "Who · when",
  "anomalies.noElement": "no element",
  "anomalies.stateConfirmedShort": "confirmed",
  "anomalies.framesWith": "Frames with anomalies",
  "anomalies.batch": "Batch",
  "anomalies.tick": "Tick {code}",
  "anomalies.ticked": "{n} ticked",
  "anomalies.batchReason": "Rejection reason",
  "anomalies.rejectTicked": "Reject {n} with this reason",
  "anomalies.untick": "clear ticks",
  "anomalies.batchDone": "{n} rejected",
  "anomalies.batchSkipped": "{n} skipped: already decided or held by others",
  "anomalies.batchUndo": "Undo",
  "anomalies.someone": "someone",
  "anomalies.eventPredicted": "proposed by the model, {rank}",
  "anomalies.eventDeclared": "declared by hand, {rank}",
  "anomalies.eventMeasured": "measured from the cloud, {rank}",
  "anomalies.eventConfirmed": "confirmed {rank} by {who}",
  "anomalies.eventConfirmedCorrected": "confirmed {rank} by {who}, box redrawn",
  "anomalies.eventRejected": "rejected by {who}: {reason}",
  "anomalies.eventWithdrawn": "verdict withdrawn by {who}: back to the queue",
  "anomalies.proposed": "(proposed {rank})",
  "anomalies.source": "Source",
  "anomalies.notExportable": "Without a frame, delivery will not export it.",
  "anomalies.decide": "Decide in the desk",
  "anomalies.openDesk": "Open in the desk",
  "anomalies.openElement": "Open the element sheet",
  "anomalies.openPhoto": "Open the frame in Photos",
  "anomalies.chooseRow": "Choose an anomaly in the list.",
  "figures.title": "The figures",
  "figures.period": "Period",
  "figures.week": "Week",
  "figures.month": "Month",
  "figures.all": "Whole job",
  "figures.reading": "Reading the figures…",
  "figures.unreachable": "The figures cannot be read now: the service does not answer.",
  "figures.computedAt": "Computed at {when}. Stages are a snapshot of now; findings and deliveries count within the period.",
  "figures.packages": "Packages by stage",
  "figures.nonePackages": "No packages.",
  "figures.acquiring": "being acquired",
  "figures.failed": "acquisition stopped",
  "figures.inReview": "under review",
  "figures.awaitingGate": "waiting for the quality gate",
  "figures.sealed": "sealed, to deliver",
  "figures.delivered": "delivered, awaiting outcome",
  "figures.accepted": "accepted by the customer",
  "figures.rejected": "rejected by the customer",
  "figures.findings": "Findings declared in the period",
  "figures.noneFindings": "No findings declared in the period.",
  "figures.total": "in total",
  "figures.deliveries": "Deliveries in the period",
  "figures.noneDeliveries": "No delivery left in the period.",
  "figures.submitted": "sent",
  "figures.withReceipt": "with receipt",
  "figures.acceptedDeliveries": "accepted",
  "figures.rejectedDeliveries": "rejected",
  "figures.behind": "The packages behind the figure",
  "role.does.upload": "brings survey packages into the platform",
  "role.does.review": "judges candidates and records manual findings",
  "role.does.quality": "freezes the work, re-checks the sample, applies the seal",
  "role.does.deliver": "composes and sends the delivery to the customer",
  "role.does.admin": "administers accounts, catalog, decisions, model and journal",
  "role.not.upload": "does not upload packages",
  "role.not.review": "does not judge candidates",
  "role.not.quality": "does not seal",
  "role.not.deliver": "does not deliver",
  "role.not.admin": "does not administer",
  "role.doesIntro": "With this role a person",
  "role.notIntro": "and",
  "users.chooseRole": "Choose a role",
  "users.roleFirst": "The role has to be chosen: none is preset, because a default is how a supervisor gets opened without anyone thinking about it.",
  "concept.critical.term": "Critical decision",
  "concept.critical.says": "It bears on what is delivered or on what the operator sees. Changing it requires writing why: six months from now a delivery that passed under a different threshold is explained only by that line.",
  "upload.zoneTitle": "Choose the survey folder",
  "upload.zoneHint": "The whole folder, not single files. It is read before a single byte is received: if something is missing you know at once. You can also drop it here.",
  "upload.zoneButton": "Choose folder",
  "upload.recognisedAs": "{name} — {cameras}, {clouds}, {trajectory}",
  "upload.camerasNone": "no camera",
  "upload.camerasOne": "one camera with {frames} frames",
  "upload.camerasMany": "{n} cameras with {frames} frames",
  "upload.cloudsNone": "no point cloud",
  "upload.cloudsOne": "one point cloud",
  "upload.cloudsMany": "{n} point clouds",
  "upload.trajectoryYes": "trajectory present",
  "upload.trajectoryNo": "trajectory missing",
  "upload.cannotIntro": "This cannot be uploaded as it is. Before trying again:",
  "title.glossary": "Glossary",
  "chrome.glossary": "Glossary",
  "glossary.intro": "The product's words, in the order you meet them while working — not alphabetical, because more often you have seen the process and do not know what the thing you saw is called. Every entry says what changes for the person working, not what the thing is. How to work, in full, is in the operator manual.",
  "glossary.operator": "At the operator's desk",
  "glossary.quality": "At the quality gate",
  "glossary.delivery": "At delivery",
  "glossary.admin": "For whoever administers",
  "hint.inGlossary": "In the glossary",
  "hint.about": "What this means: {term}",
  "concept.lease.term": "Lease",
  "concept.lease.says": "This candidate is yours for ninety seconds — a reservation: nobody else can see it. If you step away it goes back to the queue for someone else, and that is normal — nothing is lost and nothing went wrong.",
  "concept.rank.term": "Rank",
  "concept.rank.says": "How severe it is, S1 to S4. Confirming at a different rank means: the anomaly is real, but not at the severity the model proposes.",
  "concept.margin.term": "Margin",
  "concept.margin.says": "A distance on its own says nothing: the threshold depends on the line voltage and on what lies under the wire. The margin puts zero at the threshold — below zero is a violation, above it is not.",
  "concept.outbox.term": "Outbox",
  "concept.outbox.says": "Verdicts you have already given that have not reached the service yet. Keep working: they leave on their own when the network is back. If one cannot be made safe, the screen tells you and does not move on.",
  "concept.intent.term": "Verdict in flight",
  "concept.intent.says": "A verdict you have already given that the service has not applied yet: it left the outbox and counts only when it lands. While it is in flight nobody picks that candidate up, and the freeze waits for it to arrive.",
  "concept.snapshot.term": "Snapshot",
  "concept.snapshot.says": "The last good read, kept in your browser for when the network is gone. From a snapshot you look, you do not decide: what you see may be minutes old, and the screen says when it is from.",  "concept.freeze.term": "Freeze",
  "concept.freeze.says": "It stops what is being checked, not the operators' work. Without it the sample would change under the eyes of whoever is looking at it.",
  "concept.sample.term": "Sample",
  "concept.sample.says": "5 % of the work, never fewer than thirty cases, drawn by strata rather than at random: in a population made almost entirely of easy cases, a uniform draw would look at almost only easy cases.",
  "concept.seal.term": "Seal",
  "concept.seal.says": "The signature saying: this job was checked, on this snapshot, with this sample. If an operator later changes a verdict the seal lapses by itself — what you checked is no longer what would be sent.",
  "concept.delivery.term": "Delivery",
  "concept.delivery.says": "The document that goes to the customer. It freezes when it is composed, not when it is sent: between the two lies the checking time, and in that time a verdict can be withdrawn.",
  "concept.catalogEdition.term": "Catalog edition",
  "concept.catalogEdition.says": "The vocabulary of codes, in the version in force. Every delivery carries its own: without it, a delivery from six months ago could no longer be explained.",
  "concept.hypothesis.term": "Hypothesis",
  "concept.hypothesis.says": "A decision we took because the customer has not answered yet. It is not a rule: it is a declared choice, and it will change when the answer arrives.",
  "delivery.scalesTitle": "Two scales side by side",
  "delivery.scalesWhy": "The § 6.5 table and our voltage-derived thresholds are neither the same numbers nor the same model. Here they sit side by side and decide nothing: no line of the delivery changes. Question 8.7 asks the customer whether the bands replace the formula or accompany it.",
  "delivery.scalesFrontier": "At {kv} kV: our contact threshold is {touch} m and their «urgent» band ends at {urgent} m; we stop attributing at {limit} m and their table runs to {table} m.",
  "delivery.scalesCounts": "{agree} agreeing · {diverge} diverging · {incomparable} not comparable",
  "delivery.scalesUnexplained": "{n} divergences with no explanation: to be understood before writing to the customer.",
  "delivery.scalesNone": "No finding carries a measured distance.",
  "delivery.colDistance": "Distance",
  "delivery.colOurs": "Us",
  "delivery.colTheirs": "ST § 6.5",
  "delivery.colVerdict": "Outcome",
  "delivery.verdict.agree": "agree",
  "delivery.verdict.diverge": "diverge",
  "delivery.verdict.incomparable": "not comparable",
  "delivery.scalesShow": "The two scales side by side",
  "delivery.issueIndex": " · anomaly {n}",
  "delivery.onHypothesis": "rests on our hypothesis «{name}»",
  "delivery.modelTitle": "Model {version}",
  "delivery.modelNone": "— none",
  "delivery.modelMetrics": "R1 {r1} · R2 {r2} · error {error}",
  "delivery.modelCounts": "{declared} human declarations, {predicted} predictions, {matched} matches",
  "delivery.modelMissing": "missing: {list}",
  "delivery.modelNote": "Model figures do not hold the delivery: this one is verified by a person.",
  "delivery.annex5": "Annex 5 thresholds",
  "delivery.fromCustomer": "required by the customer",
  "delivery.ourHypothesis": "our hypothesis",
  "export.offline": "Offline: read-only, no outcome is recorded.",
  "export.snapshot": "Snapshot from {when} — this is not a read from the service.",
  "export.outcomeFailed": "Outcome not recorded.",
  "export.customerOutcome": "Customer outcome",
  "export.accept": "Record accepted",
  "export.rejectReason": "Rejection reason",
  "export.externalRef": "External reference",
  "export.reject": "Record rejected",
  "export.docFailed": "The document cannot be downloaded right now.",
  "lifecycle.unread": "Stages could not be read",
  "lifecycle.reading": "Reading stages…",
  "lifecycle.heading": "Package processing",
  "lifecycle.leftBehind": "Left behind",
  "lifecycle.noteOutsideUploader": "Arrived outside the uploader: nothing to count here.",
  "lifecycle.leftNote": "At delivery these items block sending: they are shown here so they are not found at validation, after the shift is already spent.",
  'flight.heading': 'The flight',
  'flight.note': 'What the customer promised, measured with the same thresholds as the delivery. Not measured is not zero.',
  'flight.sampled': 'exposure and focus read on {n} of {of} frames',
  'flight.colPromise': 'Promise',
  'flight.colMeasured': 'Measured',
  'flight.colBound': 'Bound',
  'flight.colState': 'State',
  'flight.colBasis': 'Basis',
  'flight.metadata': 'Frames with pose and optics',
  'flight.altitude': 'Height above the pole tops',
  'flight.gsd': 'Ground detail (median)',
  'flight.gsdPromised': 'Ground detail as promised',
  'flight.swath': 'Swath covered by the shots',
  'flight.density': 'Point cloud density',
  'flight.cir': 'Conductor interruptions (CIR)',
  'flight.wsr': 'Gaps in the swath (WSR)',
  'flight.sir': 'Gaps at the poles (SIR)',
  'flight.exposure': 'Well-exposed frames',
  'flight.focus': 'Frames in focus',
  'flight.within': 'within',
  'flight.outside': 'outside',
  'flight.outsideBlocks': 'outside · blocks delivery',
  'flight.unmeasured': 'not measured',
  'flight.basisNorm': 'norm',
  'flight.basisContract': "customer's promise",
  'flight.basisHypothesis': 'our hypothesis',
  "pool.session": "Review session",
  "pool.sessionOpen": "Session open · {n} reserved candidates · {heartbeat}",
  "pool.degraded": "degraded connection",
  "pool.heartbeat": "heartbeat every {n}s",
  "pool.contended": "No free candidate on this job: someone else is already working it.",
  "pool.closeSession": "Close the session",
  "cockpit.source": "Source",
  "cockpit.element": "Element",
  "cockpit.lease": "Lease",
  "cockpit.expires": " · expires {when}",
  "cockpit.norm": "standard",
  "cockpit.notExportable": "No frame covers it: it is not exportable.",
  "cockpit.drawBox": "Redraw the box by dragging.",
  "cockpit.modeRank": "Rank mode: digit 1 to 4 declares the rank and confirms. Esc to exit.",
  "cockpit.modeReason": "Reason mode: the digit chooses the rejection reason. Esc to exit.",
  "cockpit.exitedRank": "Out of rank mode: verdict and navigation letters return.",
  "cockpit.exitedReason": "Out of reason mode: the digit no longer picks a reason, it confirms again.",
  "cockpit.exitedDraw": "Out of box drawing: the previous box remains.",
  "cockpit.boxCorrected": "Corrected box: it goes with the confirmation.",
  "cockpit.polygonCorrected": "Contour drawn: it goes with the confirmation, with the box that contains it.",
  "cockpit.drawPolygon": "Draw the contour: one click per vertex, Enter or double click to close, Backspace removes the last vertex.",
  "cockpit.observe": "Desk in observation only: without a review session you look at the work, you do not decide. Start a session here, or reopen the queue from the pool.",
  "cockpit.startHere": "Start a session here",
  "cockpit.otherViews": "other views",
  "cockpit.turnOver": "The turn on this job is over: reopen the queue from the pool to resume deciding.",
  "cockpit.lastCandidate": "Last candidate of the batch: there is no next one to look at.",
  "cockpit.firstCandidate": "First candidate of the batch: there is no previous one to look at.",
  "cockpit.noStrip": "The frame strip is not loaded: this candidate has no frame, or the service did not answer.",
  "cockpit.firstFrame": "First frame of this camera: there is no previous one.",
  "cockpit.lastFrame": "Last frame of this camera: there is no next one.",
  "cockpit.lookingElsewhere": "You are looking at a frame with no candidate in the queue: here you look, you do not decide. J or K return to the candidate, G declares an anomaly on this frame.",
  "cockpit.lookAlt": "Frame {filename}, no candidate in the queue: recorded anomalies are drawn on top",
  "cockpit.lookNoPyramid": "Frame {filename} has no pyramid yet: it cannot be opened here.",
  "cockpit.frameStrip": "Frame strip",
  "cockpit.frameOf": "Frame {n} of {total}",
  "cockpit.hudCamera": "camera {name}",
  "cockpit.frameCandidates": "{n} candidates",
  "cockpit.frameFindings": "{n} anomalies",
  "cockpit.frameReviewed": "reviewed",
  "cockpit.frameUnreviewed": "not reviewed",
  "cockpit.stripReading": "Reading the strip…",
  "cockpit.stripEmpty": "No frame under this candidate.",
  "cockpit.tools": "Canvas tools",
  "cockpit.toolsNoFrame": "No frame to work on",
  "cockpit.toolBox": "Redraw the box",
  "cockpit.toolPolygon": "Draw the contour",
  "cockpit.toolOne": "Scale 1:1",
  "cockpit.toolFit": "Fit the frame",
  "cockpit.toolFinding": "Go to the finding",
  "cockpit.toolHide": "Hide overlays",
  "cockpit.keySpace": "Space",
  "cockpit.drawingBox": "Drag on the frame · Esc cancels",
  "cockpit.drawingPolygon": "{n} vertices · one click per vertex · Enter closes · Backspace removes · Esc cancels",
  "cockpit.noManualExit": "Photos open from the job: this desk has no exit.",
  "cockpit.nothingToDefer": "This candidate is not held by this session: there is nothing to return.",
  "cockpit.offlineDefer": "Offline: returning needs the service. Decide what you hold, or wait for the network.",
  "cockpit.deferFailed": "The return did not reach the service: the candidate stays held until the lease expires.",
  "cockpit.s1Blocked": "S1 has no level in the Technical Specification: confirm at S2 if there is work, or declare a false positive.",
  "cockpit.queueReadFailed": "Queue could not be read: {message}",
  "cockpit.verdictUnrecorded": "Verdict not recorded: {message}",
  "cockpit.routeConflict": "Route conflict",
  "cockpit.routeConflictActive": "Active route conflict:",
  "cockpit.openConflict": "Open the route context of the conflict",
  "cockpit.hideNotice": "Hide the notice",
  "cockpit.queueUnread": "Queue not read",
  "cockpit.queueUnreadBody": "The queue was not re-read: {detail}",
  "cockpit.queueUnreadHint": "What you hold remains decidable: re-reading is to see the rest of the batch.",
  "cockpit.rereadQueue": "Re-read the queue",
  "cockpit.verdictUnrecordedTitle": "Verdict not recorded",
  "cockpit.candidateBack": "The candidate is back in front: it must be decided again.",
  "cockpit.retryFromStrip": "Pick it up from the strip when you want: it stays written in the fault list.",
  "cockpit.readingQueue": "Reading the queue…",
  "cockpit.queueUnreadEmpty": "The queue was not read: try again from the notice above.",
  "cockpit.contendedEmpty": "No free candidate on this job: others are working it. Return to the pool or try again shortly.",
  "cockpit.noneWaiting": "No candidate waiting on this job: there is nothing else to decide here.",
  "cockpit.noneWaitingNext": "The next step is on the Overview.",
  "cockpit.candidateGone": "The candidate named here no longer exists on this job.",
  "cockpit.readingCandidate": "Reading the candidate…",
  "cockpit.alreadyDecided": "This candidate already has a verdict: here you read it, you do not decide again. To change it, go through the queue.",
  "cockpit.notInBatch": "This candidate is not in your batch: you look at it, you do not decide it. Pick it up from the queue to decide it.",
  "cockpit.decidedConfirmed": "Confirmed {rank}",
  "cockpit.decidedRejected": "Rejected: {reason}",
  "cockpit.decidedBy": "by {who}, {when}",
  "cockpit.batchDone": "Batch exhausted: close the session to return what remains, or go back to the pool for more.",
  "cockpit.modeDraw": "BOX DRAWING",
  "cockpit.modeDrawPolygon": "CONTOUR DRAWING",
  "cockpit.modePickReason": "CHOOSE REASON",
  "cockpit.modePickRank": "CHOOSE RANK",
  "cockpit.viewer": "Candidate under review",
  "cockpit.noFrameDecide": "No photo of this point. Decide by code, rank and margin; delivery will not export it.",
  "cockpit.altFrame": "Frame of candidate {name}",
  "cockpit.altFrameFile": "Frame of candidate {name}, file {filename}",
  "cockpit.sessionState": "Session status",
  "cockpit.job": "Job",
  "cockpit.sessionOpen": "open · expires at {when}",
  "cockpit.waitingCount": "{n} waiting",
  "cockpit.decidedCount": "{n} decided",
  "cockpit.toSend": "{n} to send",
  "cockpit.opening": "Opening the session…",
  "cockpit.resumed": "Session resumed: candidates were already held by this tab.",
  "cockpit.closeSession": "Close the session",
  "cockpit.backToPool": "Back to the pool",
  "cockpit.queueStrip": "Orientation queue",
  "cockpit.queueEmpty": "Queue empty.",
  'error.leaseLost':
    'The lease has expired: the candidate has returned to the queue and must be picked up again.',
  'error.leaseNotYours': 'The lease belongs to someone else: wait, or expire it with a reason.',
  'error.leaseMismatch': 'The token belongs to another candidate.',
  'error.sessionExpired': 'The review session has expired: reopen the queue from the pool.',
  'error.intentStale': 'The verdict in flight no longer holds: pick up the candidate and decide again.',
  'error.staleEpoch': 'The review of this job was reopened in the meantime: previous work no longer applies, start from what is there now.',
  'error.leaseLimit': 'You already hold the maximum number of candidates: decide or release one before taking more.',
  'error.candidateLeased': 'The candidate is held by another session: wait, or a supervisor forces its expiry with a reason.',
  'error.candidatePending': 'A verdict is already in flight on this candidate: wait for it to land.',
  'error.coveragePending': 'A declaration is already in flight on this element: wait for it to land.',
  'error.sessionClosed': 'The review session is closed: reopen the queue from the pool.',
  'error.intentRejected': 'The service rejected this verdict: insisting will not record it. Pick up the candidate and decide again.',
  'error.versionConflict': 'The candidate changed since you took it — someone else decided or the work was reopened: pick it up and decide on the current state.',
  'error.coverageConflict': 'The coverage of this element changed in the meantime: the declaration must be redone on the current state.',
  'error.notYours': 'Only your own verdict can be undone; on someone else\'s you decide again.',
  'error.nothingToUndo': 'The candidate has no verdict to undo.',
  'error.undoElapsed': 'The time to undo has passed: pick up the candidate and decide again.',
  'error.shadowPrediction': 'This proposal comes from a model not yet validated: look, do not decide.',
  'error.freezeBlocked': 'The freeze does not start: someone is still working, or conflicts and gaps remain to close.',
  'error.coverageIncomplete': 'Coverage still has gaps: the seal does not close an uncovered job.',
  'error.coverageInFlight': 'Coverage declarations are still in flight: wait for them to land.',
  'error.notFrozen': 'The job is not frozen: first freeze, then sample and seal.',
  'error.emptyPopulation': 'There are no standing verdicts to sample.',
  'error.sampleIncomplete': 'The sample is not complete: every case must be confirmed or overturned before the seal.',
  'error.sampleNotCurrent': 'The sample belongs to a previous freeze: draw it again.',
  'error.notInSample': 'This candidate is not in the sample: the re-check is done on the sample, not on the queue.',
  'error.sealBlocked': 'The seal does not pass: conflicts or invalid findings remain.',
  'error.sealMissing': 'The delivery cannot be composed without a valid quality seal.',
  'error.sealStale': 'The seal no longer holds: a verdict changed afterwards, or the freeze fell. Re-check and seal again.',
  'error.noActiveCatalog': 'No catalog edition is active: the delivery carries the edition stamp, and without one it cannot be composed.',
  'error.deliveryInvalidated': 'This delivery was withdrawn: the freeze fell. It is neither validated nor sent.',
  'error.alreadySubmitted': 'This delivery has already left: what left is not revised, a new delivery is composed.',
  'error.notSubmitted': 'The receipt is born with the send: this delivery has not left yet.',
  'error.noteRequired': 'Sending with open warnings requires a written justification, which stays with the delivery.',
  'error.reasonRequired': 'The reason is mandatory: without it, nobody knows what to correct.',
  'error.referenceRequired': "The reference of the customer's communication is mandatory: without it, nobody knows where the rejection comes from.",
  'error.metricsNotMet': 'The figures are not yet enough to show the model.',
  'error.lastManager': 'It is the last account that can open others: touching it would lock the door from inside.',
}
